import React, { useState, useEffect, useRef } from "react";
import { Toaster, toast } from "react-hot-toast";
import { showToast } from "../../Helpers/showToast";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { API_URL, API_URL_SA } from "../../env";
import { POST } from "../../Services/AxiosService";
import { CustomStringify } from "../../Helpers/CustomStringify";
import { DateToShow } from "../../Helpers/DateToShow";
import { DateToShowSplit } from "../../Helpers/DateToShowSplit";
import TypeCase from "../../Helpers/TypeCase";
import { useSelector, useDispatch } from "react-redux";
import { fetchDataPK } from "../../Redux/TransactionsData/PackingChallanDataSlice";
import { fetchListAC } from "../../Redux/CommonListData/AccountNameListSlice";
import { fetchListAgent } from "../../Redux/CommonListData/AgentNameListSlice";
import { fetchListTMBR } from "../../Redux/CommonListData/TeamMemberNameListSlice";
import { fetchListTrans } from "../../Redux/CommonListData/TransportNameListSlice";
import { fetchListFG } from "../../Redux/CommonListData/DesignNameListSlice";
import { fetchListSUPFG } from "../../Redux/CommonListData/SupplyDesignNameListSlice";
import { numberToWords } from "amount-to-words";

import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { IconButton, Stack } from "@mui/material";
import AddCircleOutlinedIcon from "@mui/icons-material/AddCircleOutlined";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import TotalDetail from "../../Components/TotalDetail/TotalDetail";
import AddColorSizeDialog from "../../Components/Dialog/AddColorSizeDialog";
import AddFGDesign from "../Masters/AddFGDesign";
import DeleteDialog from "../../Components/Dialog/DeleteDialog";
import PasswordDialog from "../../Components/Dialog/PasswordDialog";
import { BarcodePrint } from "../../Components/BarcodePrint/BarcodePrint";
import { PrintReport } from "../../Components/Print/PrintReport";
import { NewBarcodePrint } from "../../Components/BarcodePrint/NewBarCodePrint";
import { fetchBarcodePrintSetting } from "../../Redux/BarcodeRateSetting/BarcodePrintSettingSlice";

export default function EditPackingChallan() {
  const [shouldReRender, setShouldReRender] = useState(false);
  const [shouldReRenderRaw, setShouldReRenderRaw] = useState(false);
  const { result, status, error } = useSelector((state) => state.PackingChallanData);
  const BarcodeRateSetting = useSelector((state) => state.BarcodeRateSetting);
  const [isBarcodePrint, setIsBarcodePrint] = useState(false)

  const { cmpdetail } = useSelector((state) => state.CompanyDetail);
  const UserDetail = useSelector((state) => state.UserDetail);

  const Theme = useSelector((state) => state.Theme);
  const AccountNameList = useSelector((state) => state.AccountNameList?.result);
  const TransportNameList = useSelector((state) => state.TransportNameList?.result);
  const SundryNameList = useSelector((state) => state.SundryNameList?.result);
  const ProductNameList = useSelector((state) => state.ProductNameList?.result);
  const SupplyDesignNameList = useSelector((state) => state.SupplyDesignNameList?.result);
  const DesignNameList = useSelector((state) => state.DesignNameList?.result);
  const ColorNameList = useSelector((state) => state.ColorNameList?.result);
  const SizeNameList = useSelector((state) => state.SizeNameList?.result);
  const BarcodeNameList = useSelector((state) => state.BarcodeNameList?.result);
  const UnitNameList = useSelector((state) => state.UnitNameList?.result);

  const BarcodeAll = useSelector((state) => state.BarcodeAll?.result);
  const DesignAll = useSelector((state) => state.DesignAll?.result);
  const ProductAll = useSelector((state) => state.ProductAll?.result);
  const ColorAll = useSelector((state) => state.ColorAll?.result);
  const SizeAll = useSelector((state) => state.SizeAll?.result);
  const LocationAll = useSelector((state) => state.LocationAll?.result);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const filter = createFilterOptions();

  const { id } = useParams();
  const [rowId, setRowId] = useState(1);
  const [itemIndex, setItemIndex] = useState();
  const [sunIndex, setSunIndex] = useState();
  const itemButton = document.getElementById("itemButton");

  const [Led_ID, setLed_ID] = useState();
  const [SONO, setSONO] = useState();
  const [BillNo, setBillNo] = useState();
  const [BillDate, setBillDate] = useState();
  const [Trp_ID, setTrp_ID] = useState();

  const [isEditItemForm, setIsEditItemForm] = useState(false);
  const [isCancle, setIsCancle] = useState(false);

  const [PackingChallanData, setPackingChallanData] = useState([]);

  console.log("PackingChallanData", PackingChallanData)

  const [itemDataArray, setitemDataArray] = useState([]);
  const [formDataItem, setformDataItem] = useState({
    supplier_id: UserDetail?.result?.user?.id,
    supplier_name: UserDetail?.result?.user?.company_name,
    del_days: "",
    design_id: "",
    supply_design: "",
    design_no: "",
    design_desc: "",
    product: "",
    hsn_code: "",
    qty: 0,
    mtrs: "",
    rate: "",
    cgst: 0,
    sgst: 0,
    igst: 0,
    et_id: 0,
    gstper: 0,
    gsttype: [],
    totalgst: 0,
    remark: "",
    colors: [
      {
        qty: 0,
        et_color_id: 0,
        colorId: 0,
        color_name: "Mix",
        sizes: [
          {
            qty: 0,
            et_size_id: 0,
            sizeId: 1,
            size_name: "No Size",
          },
        ],
      },
    ],
    images: [],
  });

  console.log(formDataItem)
  const [SuppDsgnNmCD, setSuppDsgnNmCD] = useState();
  const [PodIdNme, setPodIdNme] = useState();
  const [ProductHSN, setProductHSN] = useState();
  const [TotalQuantity, setTotalQuantity] = useState();
  const [DsgRate, setDsgRate] = useState();
  const [isDisAmt, setIsDisAmt] = useState(false);
  const [DiscountPer, setDiscountPer] = useState(UserDetail?.result?.user?.discount_per || 0);
  const [DiscountAmt, setDiscountAmt] = useState();
  const [AmountBFT, setAmountBFT] = useState();
  const [cgstValue, setcgstValue] = useState();
  const [sgstValue, setsgstValue] = useState();
  const [igstValue, setigstValue] = useState();
  const [itemTotalAmt, setitemTotalAmt] = useState();

  const [passunitkey, setpassunitkey] = useState(0);
  const [QtyInputfocus, setQtyInputfocus] = useState(false);
  const [setQtyCheck, setSetQtyCheck] = useState(false);
  const [GstRates, setGstRates] = useState({});
  const [TaxRanges, setTaxRanges] = useState({});
  const [newArray, setNewArray] = useState([]);

  const [dsgwiseData, setDsgwiseData] = useState([]);
  const [UniqueSizes, setUniqueSizes] = useState([]);
  const [RawClrSize, setRawClrSize] = useState([]);

  const [mainTotalQty, setMainTotalQty] = useState();
  const [mainTotalDiscount, setMainTotalDiscount] = useState();
  const [mainTotalTaxableAmt, setMainTotalTaxableAmt] = useState();
  const [mainTotalItemCgst, setMainTotalItemCgst] = useState();
  const [mainTotalItemSgst, setMainTotalItemSgst] = useState();
  const [mainTotalItemIgst, setMainTotalItemIgst] = useState();
  const [mainTotalAmount, setMainTotalAmount] = useState();

  const [DesignName, setDesignName] = useState();

  const [Loader, setLoader] = useState(false);
  const [IsClrSize, setIsClrSize] = useState(false);

  const handleSwitchClrSize = async (event) => {
    const { checked } = event.target;
    setIsClrSize(checked);

    setShouldReRenderRaw(true);
    setTimeout(() => setShouldReRenderRaw(false), 1);
  };

  const [ItemRadio, setItemRadio] = useState("1");

  const handleItemRadio = (event) => {
    setItemRadio(event.target.value);
    emptyFormData();
  };

  const [tabValue, setTabValue] = useState("1");

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const [modalOpenAddNew, setModalOpenAddNew] = useState(false);
  const [modalOpenAddClrSize, setModalOpenAddClrSize] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenDelete, setModalOpenDelete] = useState(false);
  const [modalOpenPassword, setModalOpenPassword] = useState(false);


  const handleModalOpenAddNew = () => {
    setModalOpenAddNew(true);
  };

  const handleModalCloseAddNew = async (event, Id) => {
    setModalOpenAddNew(false);

    if (DesignName && Id?.value) {
      dispatch(fetchListSUPFG({ cmpdetail, UserDetail }));

      emptyFormData();
      setSuppDsgnNmCD(Id);
      await GetSupDesignDetails(Id?.value);
      setformDataItem((prevData) => ({
        ...prevData,
        design_id: Id?.value,
        supply_design: Id?.label,
        design_no: Id?.design_no,
      }));
    }

    setDesignName();

    setShouldReRender(true);
    setTimeout(() => setShouldReRender(false), 1);
  };

  const handleModalOpenAddClrSize = () => {
    setModalOpenAddClrSize(true);
  };

  const handleModalCloseAddClrSize = (event, Id) => {
    setModalOpenAddClrSize(false);
  };

  const handleModalOpen = () => {
    if (Led_ID) {
      setModalOpen(true);
      setIsEditItemForm(false);
      emptyFormData();
    } else {
      showToast("Please Select Account", "error");
    }
  };

  const handleModalEdit = (item, index) => {
    setModalOpen(true);
    editFormData(item, true);
    setItemIndex(index);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setItemIndex();
  };

  const handleModalOpenDelete = (index, tab) => {
    setModalOpenDelete(true);
    if (tab == 1) {
      setItemIndex(index);
    } else {
      setSunIndex(index);
    }
  };

  const handleModalCloseDelete = () => {
    setModalOpenDelete(false);
    setItemIndex();
    setSunIndex();
  };

  const handleModalOpenPassword = () => {
    setModalOpenPassword(true);
  };

  const handleModalClosePassword = () => {
    setModalOpenPassword(false);
  };

  const [DesignMasterData, setDesignMasterData] = useState();

  //   useEffect(() => {
  //     if (FGDesignMasterDataExp?.status === "idle") {
  //       dispatch(fetchDataFGExp(cmpdetail));
  //     } else if (FGDesignMasterDataExp?.status === "succeeded") {
  //       if (FGDesignMasterDataExp?.result?.status == true) {
  //         setDesignMasterData(FGDesignMasterDataExp?.result?.data);
  //       } else {
  //         showToast(FGDesignMasterDataExp?.result?.message, "error");
  //       }
  //     } else if (FGDesignMasterDataExp?.status === "failed") {
  //       showToast(FGDesignMasterDataExp?.error, "error");
  //     }
  //   }, [FGDesignMasterDataExp?.status]);

  const [allBarcodesData, setAllBarcodesData] = useState([]);
  const GetBarcodesById = async () => {
    setLoader(true);
    var myHeaders = new Headers();
    myHeaders.append("Access-Control-Allow-Origin", "*");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      // body: raw,
      redirect: "follow",
    };

    const response = await fetch(`${API_URL}/purchase/barcodes/${cmpdetail?.key}/${id}`, requestOptions);
    const result = await response.json();

    console.log("BarcodeInfo", { result })
    if (result?.success == true) {
      setLoader(false);

      let newArr = [];
      result?.data?.map((item) => {
        newArr?.push({
          "Barcode_BarcodeNo": item?.barcodeNo,
          "Barcode_DesignID": item?.productId,
          "Barcode_Design": item?.design_no,
          "Barcode_ColourID": item?.colorId,
          "Barcode_Colour": item?.color_name,
          "Barcode_SizeID": item?.sizeId,
          "Barcode_Size": item?.size_name,
          "Quantity": item?.qty,

          // new
          "Barcode_DesignGrp": item?.design_group,
          "Barcode_DesignPtrn": item?.pattern,
          "Barcode_Department": item?.department,
          "Barcode_Product": result?.product,
          "Barcode_RateChart": JSON.parse(item?.ratechart || "{}"),
          "Rate": item?.rate - ((Number(item?.discount_per) / 100) * item?.rate)
        })
      })

      console.log("BarcodePrintReadyData", newArr)
      setAllBarcodesData(newArr);

      setShouldReRender(true);
      setTimeout(() => setShouldReRender(false), 1);

    } else {
      // showToast(result?.message, "error");
      setLoader(false);
    }
  };


  const fieldVal = (content, Barcode_Design, Barcode_DesignID, Rate) => {
    const BarRate = BarcodeRateSetting?.cmpdetail;
    const BarRateCode = (rate) => {
      let codedRate = "";
      String(rate).split('')?.map((item) => {
        return codedRate += BarRate?.barcode_rate_encrption_codes[Number(item)]
      })

      if (BarRate?.barcode_rate_encrption_check && BarRate?.barcode_rate_prefix_check && BarRate?.barcode_rate_postfix_check) {
        return BarRate?.barcode_rate_prefix + (BarRate?.barcode_rate_encrption_codes?.length > 0 ? codedRate : rate) + BarRate?.barcode_rate_postfix;
      } else if (!BarRate?.barcode_rate_encrption_check && BarRate?.barcode_rate_prefix_check && BarRate?.barcode_rate_postfix_check) {
        return BarRate?.barcode_rate_prefix + rate + BarRate?.barcode_rate_postfix;
      } else if (BarRate?.barcode_rate_encrption_check && !BarRate?.barcode_rate_prefix_check && BarRate?.barcode_rate_postfix_check) {
        return (BarRate?.barcode_rate_encrption_codes?.length > 0 ? codedRate : rate) + BarRate?.barcode_rate_postfix;
      } else if (BarRate?.barcode_rate_encrption_check && BarRate?.barcode_rate_prefix_check && !BarRate?.barcode_rate_postfix_check) {
        return BarRate?.barcode_rate_prefix + (BarRate?.barcode_rate_encrption_codes?.length > 0 ? codedRate : rate);
      } else if (!BarRate?.barcode_rate_encrption_check && !BarRate?.barcode_rate_prefix_check && BarRate?.barcode_rate_postfix_check) {
        return rate + BarRate?.barcode_rate_postfix;
      } else if (!BarRate?.barcode_rate_encrption_check && BarRate?.barcode_rate_prefix_check && !BarRate?.barcode_rate_postfix_check) {
        return BarRate?.barcode_rate_prefix + rate;
      } else if (BarRate?.barcode_rate_encrption_check && !BarRate?.barcode_rate_prefix_check && !BarRate?.barcode_rate_postfix_check) {
        return (BarRate?.barcode_rate_encrption_codes?.length > 0 ? codedRate : rate);
      } else if (!BarRate?.barcode_rate_encrption_check && !BarRate?.barcode_rate_prefix_check && !BarRate?.barcode_rate_postfix_check) {
        return rate;
      }
    }


    const roundToNearest = (num, NearestValue) => {
      if (NearestValue) {
        return Math.round(num / NearestValue) * NearestValue;
      } else {
        return num;
      }
    }

    const Rates = {
      MRPPer: UserDetail?.result?.user?.MRPPer,
      MRP2Per: UserDetail?.result?.user?.MRP2Per,
      MRP3Per: UserDetail?.result?.user?.MRP3Per,
      MRP4Per: UserDetail?.result?.user?.MRP4Per,
      MRP5Per: UserDetail?.result?.user?.MRP5Per,
      WSPer: UserDetail?.result?.user?.WSPer,
      WS2Per: UserDetail?.result?.user?.WS2Per,
      WS3Per: UserDetail?.result?.user?.WS3Per,
      WS4Per: UserDetail?.result?.user?.WS4Per,
      WS5Per: UserDetail?.result?.user?.WS5Per,
      LastDigit: UserDetail?.result?.user?.LastDigit,
      NearestValue: UserDetail?.result?.user?.NearestValue,
      IsMUMarkup: UserDetail?.result?.user?.IsMUMarkup,
    }

    let WSL1 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(Rate) + ((Rates?.WSPer / 100) * Rate) : Number(Rate) + ((Number(Rate) / (100 - Rates?.WSPer)) * (Rates?.WSPer))), Rates?.NearestValue);
    let MRPL1 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(Rate) + ((Rates?.MRPPer / 100) * Rate) : Number(Rate) + ((Number(Rate) / (100 - Rates?.MRPPer)) * (Rates?.MRPPer))), Rates?.NearestValue);
    let WSL2 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(Rate) + ((Rates?.WS2Per / 100) * Rate) : Number(Rate) + ((Number(Rate) / (100 - Rates?.WS2Per)) * (Rates?.WS2Per))), Rates?.NearestValue);
    let MRPL2 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(Rate) + ((Rates?.MRP2Per / 100) * Rate) : Number(Rate) + ((Number(Rate) / (100 - Rates?.MRP2Per)) * (Rates?.MRP2Per))), Rates?.NearestValue);
    let WSL3 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(Rate) + ((Rates?.WS3Per / 100) * Rate) : Number(Rate) + ((Number(Rate) / (100 - Rates?.WS3Per)) * (Rates?.WS3Per))), Rates?.NearestValue);
    let MRPL3 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(Rate) + ((Rates?.MRP3Per / 100) * Rate) : Number(Rate) + ((Number(Rate) / (100 - Rates?.MRP3Per)) * (Rates?.MRP3Per))), Rates?.NearestValue);
    let WSL4 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(Rate) + ((Rates?.WS4Per / 100) * Rate) : Number(Rate) + ((Number(Rate) / (100 - Rates?.WS4Per)) * (Rates?.WS4Per))), Rates?.NearestValue);
    let MRPL4 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(Rate) + ((Rates?.MRP4Per / 100) * Rate) : Number(Rate) + ((Number(Rate) / (100 - Rates?.MRP4Per)) * (Rates?.MRP4Per))), Rates?.NearestValue);
    let WSL5 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(Rate) + ((Rates?.WS5Per / 100) * Rate) : Number(Rate) + ((Number(Rate) / (100 - Rates?.WS5Per)) * (Rates?.WS5Per))), Rates?.NearestValue);
    let MRPL5 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(Rate) + ((Rates?.MRP5Per / 100) * Rate) : Number(Rate) + ((Number(Rate) / (100 - Rates?.MRP5Per)) * (Rates?.MRP5Per))), Rates?.NearestValue);

    const RateChart = {
      "WS L1": Rates?.WSPer ? Rates?.LastDigit ? String(WSL1)?.slice(0, ((String(WSL1)?.length > String(Rates?.LastDigit)?.length ? String(WSL1)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : WSL1 : 0,
      "MRP L1": Rates?.MRPPer ? Rates?.LastDigit ? String(MRPL1)?.slice(0, ((String(MRPL1)?.length > String(Rates?.LastDigit)?.length ? String(MRPL1)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : MRPL1 : 0,
      "WS L2": Rates?.WS2Per ? Rates?.LastDigit ? String(WSL2)?.slice(0, ((String(WSL2)?.length > String(Rates?.LastDigit)?.length ? String(WSL2)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : WSL2 : 0,
      "MRP L2": Rates?.MRP2Per ? Rates?.LastDigit ? String(MRPL2)?.slice(0, ((String(MRPL2)?.length > String(Rates?.LastDigit)?.length ? String(MRPL2)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : MRPL2 : 0,
      "WS L3": Rates?.WS3Per ? Rates?.LastDigit ? String(WSL3)?.slice(0, ((String(WSL3)?.length > String(Rates?.LastDigit)?.length ? String(WSL3)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : WSL3 : 0,
      "MRP L3": Rates?.MRP3Per ? Rates?.LastDigit ? String(MRPL3)?.slice(0, ((String(MRPL3)?.length > String(Rates?.LastDigit)?.length ? String(MRPL3)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : MRPL3 : 0,
      "WS L4": Rates?.WS4Per ? Rates?.LastDigit ? String(WSL4)?.slice(0, ((String(WSL4)?.length > String(Rates?.LastDigit)?.length ? String(WSL4)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : WSL4 : 0,
      "MRP L4": Rates?.MRP4Per ? Rates?.LastDigit ? String(MRPL4)?.slice(0, ((String(MRPL4)?.length > String(Rates?.LastDigit)?.length ? String(MRPL4)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : MRPL4 : 0,
      "WS L5": Rates?.WS5Per ? Rates?.LastDigit ? String(WSL5)?.slice(0, ((String(WSL5)?.length > String(Rates?.LastDigit)?.length ? String(WSL5)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : WSL5 : 0,
      "MRP L5": Rates?.MRP5Per ? Rates?.LastDigit ? String(MRPL5)?.slice(0, ((String(MRPL5)?.length > String(Rates?.LastDigit)?.length ? String(MRPL5)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : MRPL5 : 0,
    }


    if (content == "Design") {
      return Barcode_Design;
    } else if (content == "Department") {
      return DesignNameList?.find((item) => {
        return item?.id == Barcode_DesignID
      })?.department;
    } else if (content == "WS Rate") {
      return RateChart?.["WS L1"] ? BarRate?.barcode_rate_multiples ? BarRateCode(RateChart?.["WS L1"] * BarRate?.barcode_rate_multiples) : BarRateCode(RateChart?.["WS L1"]) : ""
    } else if (content == "MRP Rate") {
      return RateChart?.["MRP L1"] ? BarRate?.barcode_rate_multiples ? BarRateCode(RateChart?.["MRP L1"] * BarRate?.barcode_rate_multiples) : BarRateCode(RateChart?.["MRP L1"]) : ""
    } else if (content == "") {
      return "";
    }
  };

  const hexToRGBFade = (hex, fade) => {
    hex = hex.replace("#", "");
    // Parse the red, green, and blue components from the hex string
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);
    // Return the RGB value
    return `rgb(${r}, ${g}, ${b}, ${fade})`;
  };

  const sortByLabel = (obj1, obj2) => {
    let label1 = obj1.label?.toLowerCase();
    let label2 = obj2.label?.toLowerCase();

    if (label1 < label2) {
      return -1;
    }
    if (label1 > label2) {
      return 1;
    }
    return 0;
  };

  function sortByLabelNumber(obj1, obj2) {
    return Number(obj1.label) - Number(obj2.label);
  }

  const [ListOpen, setListOpen] = useState(false);
  const [ListLoading, setListLoading] = useState(false);

  const [dsgnList, setdsgnList] = useState([]);
  const [SupplydsgnList, setSupplydsgnList] = useState([]);

  const [prodList, setprodList] = useState([]);

  const handleListOpen = async (event) => {
    setListOpen(true);
    setListLoading(true);

    const myPromise = new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(true);
      }, 300);
    });
    await myPromise;

    setListLoading(false);

    setSupplydsgnList(SupplyDesignNameList?.map((item) => ({
      value: item.id,
      label: item.supply_design,
      design_no: item?.design_no,
      product: item?.product,
    })) || []);

    setprodList(
      ProductNameList?.map((item) => ({
        value: item.pdtid,
        label: item.pdt_code,
      })) || []
    );
  };

  const handleListClose = () => {
    setListOpen(false);
    setdsgnList([]);
    setSupplydsgnList([]);
    setprodList([]);
  };


  const LedgerList = AccountNameList?.map((item) => ({
    value: item.id,
    label: item.company_name,
    address: item.address,
    mobile_no: item.mobile_no,
    GSTIN: item.GSTIN,
    PINCode: item.PINCode,
    et_state_id: item.et_state_id,
    state: item.state,
    et_city_id: item.et_city_id,
    city: item.city,
    et_broker_id: item.et_broker_id,
    broker: item.broker,
  }));

  const transList = TransportNameList?.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const barCodeList = BarcodeNameList?.map((item) => ({
    value: item.Barcode_ID,
    label: item.Barcode_BarcodeNo,
  })) || [];

  const ColorList = ColorNameList?.map((item) => ({
    value: item.mstcolour_id,
    label: item.mstcolour_name,
  }));

  const SizeList = SizeNameList?.map((item) => ({
    value: item.SizeId,
    label: item.SizeCode,
  }));

  const getPackingChallanById = async () => {
    const PackingChallan = result?.data?.find((item) => item?.id == id);
    setPackingChallanData(PackingChallan);
    setLed_ID({
      value: PackingChallan?.supplierId,
      label: PackingChallan?.supplier_name,
    });
    setSONO(PackingChallan?.purchase_no);
    setBillNo(PackingChallan?.bill_no);
    setBillDate(PackingChallan?.bill_date);
    setTrp_ID({
      value: PackingChallan?.et_transport_id,
      label: PackingChallan?.transport,
    });
    setitemDataArray(PackingChallan?.OrderDesign?.map((item) => {
      let disRate = (Number(item?.discount_per) / 100) * Number(item?.rate);
      let discountedRate = Number(item?.rate) - ((Number(item?.discount_per) / 100) * Number(item?.rate));

      return {
        ...item,
        discount_amount: (Number(item?.qty) * disRate).toFixed(2),
        purchaseId: Number(item?.purchaseId || 0),
        amountbft: (Number(item?.qty) * discountedRate).toFixed(2),
        cgstamt: ((Number(item?.qty) * discountedRate) * ((item?.gsttype?.includes("cgst") ? item?.cgst : 0) / 100)).toFixed(2),
        sgstamt: ((Number(item?.qty) * discountedRate) * ((item?.gsttype?.includes("sgst") ? item?.sgst : 0) / 100)).toFixed(2),
        igstamt: ((Number(item?.qty) * discountedRate) * ((item?.gsttype?.includes("igst") ? item?.igst : 0) / 100)).toFixed(2),
        amount: ((Number(item?.qty) * discountedRate) + (Number(item?.qty) * discountedRate) * (item?.totalgst / 100)).toFixed(2)
      }
    }))

    setShouldReRender(true);
    setTimeout(() => setShouldReRender(false), 1);
  };

  const deleteFormData = (index) => {
    setitemDataArray((prev) => {
      return prev?.map((item, ind) => {
        if (index == ind) {
          setIsCancle(true);
          return { ...item, is_cancel: true }
        } else {
          return { ...item }
        }
      })
    });
    handleModalCloseDelete();
  };

  const editFormData = async (item, isEdit) => {
    emptyFormData();
    setIsEditItemForm(isEdit);
    if (item?.colors?.find(
      (elem) => elem.color_name.toLowerCase() != "Mix".toLowerCase()
    )) {
      setIsClrSize(true);
    }
    setformDataItem({ ...item });
    setSuppDsgnNmCD(
      item?.design_id
        ? {
          value: item?.design_id,
          label: item?.supply_design,
          design_no: item?.design_no,
          product: item?.product,
        }
        : ""
    );
    setPodIdNme(
      item?.design_id
        ? {
          value: item?.product_id,
          label: item?.product,
        }
        : ""
    );
    setProductHSN(item?.hsn_code ? item?.hsn_code : "");
    setDsgRate(item?.rate ? item?.rate : "");

    let Rates = {
      cgst: 0,
      sgst: 0,
      igst: 0,
    };
    item?.gsttype?.map((itemm) => {
      Rates[itemm] = item?.[itemm];
    });
    setGstRates(Rates);

    let Data = await GetSupDesignDetails(item?.design_id, true);

    setUniqueSizes(Data?.usizes);
    const updatedRawClrSize = Data?.rawClrSize?.map((item1) => {
      const matchingColor = item?.colors?.find(
        (item2) => item2.color_name == item1.color_name
      );
      if (matchingColor) {
        const updatedSizes = item1.sizes?.map((item3) => {
          const matchingSize = matchingColor.sizes.find(
            (item4) => item4.size_name === item3.size_name
          );
          if (matchingSize) {
            return { ...item3, qty: matchingSize.qty, size_dtltlb_id: matchingSize?.size_dtltlb_id || 0 };
          } else {
            return { ...item3, size_dtltlb_id: 0 };
          }
        });

        return { ...item1, sizes: updatedSizes, orderDetailId: matchingColor?.orderDetailId || 0 };
      } else {
        return { ...item1, orderDetailId: 0 };
      }
    });
    setRawClrSize(updatedRawClrSize);

    setDsgRate(item?.rate ? item?.rate : "");
    setDiscountPer(item?.discount_per ? item?.discount_per : "");
    setDiscountAmt(item?.discount_amount ? item?.discount_amount : "");
    setTotalQuantity(item?.qty ? item?.qty : "");
    setAmountBFT(item?.amountbft ? item?.amountbft : "");
    setcgstValue(item?.cgstamt ? item?.cgstamt : "");
    setsgstValue(item?.sgstamt ? item?.sgstamt : "");
    setigstValue(item?.igstamt ? item?.igstamt : "");
    setitemTotalAmt(item?.amount ? item?.amount : "");

    setShouldReRender(true);
    setTimeout(() => setShouldReRender(false), 1);
  };

  const emptyFormData = () => {
    setformDataItem({
      supplier_id: UserDetail?.result?.user?.id,
      supplier_name: UserDetail?.result?.user?.company_name,
      del_days: "",
      design_id: "",
      supply_design: "",
      design_no: "",
      design_desc: "",
      product: "",
      hsn_code: "",
      qty: 0,
      mtrs: "",
      rate: "",
      cgst: 0,
      sgst: 0,
      igst: 0,
      et_id: 0,
      gstper: 0,
      gsttype: [],
      totalgst: 0,
      remark: "",
      colors: [
        {
          qty: 0,
          sizes: [
            {
              qty: 0,
              sizeId: 1,
              size_name: "No Size",
              et_size_id: 0,
            },
          ],
          color_name: "Mix",
        },
      ],
      images: [],
    });

    setSuppDsgnNmCD();
    setPodIdNme();
    setProductHSN();
    setTotalQuantity();
    setDsgRate();
    setDiscountPer(UserDetail?.result?.user?.discount_per);
    setDiscountAmt();
    setIsDisAmt(false);
    setAmountBFT();
    setcgstValue();
    setsgstValue();
    setigstValue();
    setitemTotalAmt();
    setNewArray([]);
    setUniqueSizes([]);
    setRawClrSize([]);
    setIsClrSize(false);
    setGstRates({});
    setTaxRanges([]);
    itemButton?.blur();

    setShouldReRender(true);
    setTimeout(() => setShouldReRender(false), 1);
  };

  const [Led_StateID, setLed_StateID] = useState();

  // const GetDesignDetails = async (d, z) => {
  //   setLoader(true);
  //   var myHeaders = new Headers();
  //   myHeaders.append("Access-Control-Allow-Origin", "*");

  //   var raw = CustomStringify({
  //     Party_ID: Led_ID?.value,
  //     Party_StateID: Led_StateID,
  //     Type: "WS",
  //     TypeLevel: 1,
  //     Server: {
  //       Database: cmpdetail?.Database,
  //       Password: cmpdetail?.Password,
  //       Server: cmpdetail?.Server,
  //       User_ID: cmpdetail?.User_ID,
  //       Port: cmpdetail?.Port,
  //     },
  //   });

  //   var requestOptions = {
  //     method: "GET",
  //     headers: myHeaders,
  //     // body: raw,
  //     redirect: "follow",
  //   };

  //   const response = await fetch(
  //     `${API_URL}/products/colorstock/${cmpdetail?.key}/${d}?same_state=1`,
  //     requestOptions
  //   );
  //   const result = await response.json();

  //   if (result?.success == true) {
  //     setLoader(false);
  //     // setIsClrSize(true);
  //     setPodIdNme({
  //       value: result?.product_id,
  //       label: result?.product,
  //     });
  //     setProductHSN(result?.hsn_code);
  //     setDsgRate(result?.rate ? result?.rate : "");
  //     let Rates = {
  //       cgst: 0,
  //       sgst: 0,
  //       igst: 0,
  //     };
  //     result?.gsttype?.map((item) => {
  //       Rates[item] = result?.[item];
  //     });
  //     setGstRates(Rates);

  //     let usizes = result?.data?.reduce((acc, item) => {
  //       item?.sizes?.map((elem) => {
  //         if (acc.includes(elem?.size_name) == false) {
  //           acc.push(elem?.size_name);
  //         }
  //       })
  //       return acc;
  //     }, []);
  //     let rawClrSize = result?.data?.filter((item) => item?.color_name != "MIX");

  //     setUniqueSizes(usizes);
  //     setRawClrSize(rawClrSize);

  //     setformDataItem((prevData) => ({
  //       ...prevData,
  //       product: result?.product,
  //       hsn_code: result?.hsn_code,
  //       rate: result?.rate,
  //       cgst: result?.cgst,
  //       sgst: result?.sgst,
  //       igst: result?.igst,
  //       totalgst: result?.totalgst,
  //       gstper: result?.gstper,
  //       gsttype: result?.gsttype,
  //     }));

  //     setShouldReRender(true);
  //     setTimeout(() => setShouldReRender(false), 1);

  //     return { usizes, rawClrSize }
  //   } else {
  //     // showToast(result?.message, "error");
  //     setLoader(false);
  //   }
  // };

  const GetSupDesignDetails = async (d, edit) => {
    setLoader(true);
    var myHeaders = new Headers();
    myHeaders.append("Access-Control-Allow-Origin", "*");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      // body: raw,
      redirect: "follow",
    };

    const response = await fetch(
      `${API_URL}/supplydesign/taxdetails/${d}/${cmpdetail?.key}`,
      requestOptions
    );
    const result = await response.json();

    if (result?.success == true) {
      setLoader(false);
      if (!edit) {
        setQtyInputfocus(true);
        setPodIdNme({
          value: result?.data?.product_id,
          label: result?.data?.product,
        });
        setProductHSN(result?.data?.hsn_code);
        setDsgRate(result?.data?.base_rate ? result?.data?.base_rate : "");
        let Rates = {
          cgst: 0,
          sgst: 0,
          igst: 0,
        };
        result?.data?.gsttype?.map((item) => {
          Rates[item] = result?.data?.[item];
        });
        setGstRates(Rates);
        setTaxRanges(result?.data?.tax_details)

        let usizes = result?.data?.colorsizes?.reduce((acc, item) => {
          item?.sizes?.map((elem) => {
            if (acc.includes(elem?.size_name) == false) {
              acc.push(elem?.size_name);
            }
          })
          return acc;
        }, []);
        let rawClrSize = result?.data?.colorsizes;

        setUniqueSizes(usizes);
        setRawClrSize(rawClrSize);

        setformDataItem((prevData) => ({
          ...prevData,
          product: result?.data?.product,
          hsn_code: result?.data?.hsn_code,
          rate: result?.data?.base_rate,
          cgst: result?.data?.cgst,
          sgst: result?.data?.sgst,
          igst: result?.data?.igst,
          totalgst: result?.data?.totalgst,
          gstper: result?.data?.gstper,
          gsttype: result?.data?.gsttype,
        }));
      } else {
        setTaxRanges(result?.data?.tax_details)
        let usizes = result?.data?.colorsizes?.reduce((acc, item) => {
          item?.sizes?.map((elem) => {
            if (acc.includes(elem?.size_name) == false) {
              acc.push(elem?.size_name);
            }
          })
          return acc;
        }, []);
        let rawClrSize = result?.data?.colorsizes;

        return { usizes, rawClrSize }
      }

      setShouldReRender(true);
      setTimeout(() => setShouldReRender(false), 1);
    } else {
      showToast(result?.message, "error");
      setLoader(false);
    }
  };

  const handleTrp_ID = async (Trp_ID) => {
    setTrp_ID(Trp_ID);
  };

  const handleSupDsnCode_ID = async (Desg_ID) => {
    if (Desg_ID?.value == 0) {
      setDesignName(Desg_ID?.label?.replaceAll('"', "").replaceAll("Add ", ""))
      handleModalOpenAddNew();
    } else {
      if (itemDataArray?.filter((item) => !item?.is_cancel)?.map((ele) => ele?.supply_design)?.includes(Desg_ID?.label)) {
        return showToast("Design Already Exists", "error");
      }

      emptyFormData();
      setSuppDsgnNmCD(Desg_ID);
      await GetSupDesignDetails(Desg_ID?.value);
      setformDataItem((prevData) => ({
        ...prevData,
        design_id: Desg_ID?.value,
        supply_design: Desg_ID?.label,
        design_no: Desg_ID?.design_no,
      }));
    }
  };

  const handleQuantity = (event) => {
    const { name, value } = event.target;
    calculateFormDataAmount(Number(value), DsgRate, DiscountPer, isDisAmt, GstRates);
    setformDataItem((prevData) => ({ ...prevData, qty: value }));
    setRawClrSize((pre) => {
      return pre?.map((item) => {
        return {
          ...item,
          sizes: item?.sizes?.map((elem) => {
            let obj = elem
            delete obj.qty
            return obj
          })
        }
      })
    })
  };

  const DiscountedRate = (rate, disPer) => {
    let discountedRatee = ((rate || 0) - ((disPer / 100) * (rate || 0)));
    let discountedRate = discountedRatee > 999 && discountedRatee < 1000 ? Math.round(discountedRatee) : discountedRatee;
    return discountedRate;
  }

  const handleRateChange = (e) => {
    const { name, value } = e.target;
    setDsgRate(value);
    setformDataItem((prevData) => ({ ...prevData, rate: value }));

    let newTax = TaxRanges?.find((item) => {
      return DiscountedRate(value, DiscountPer) >= item?.from && DiscountedRate(value, DiscountPer) <= item?.to
    })

    let Rates = {
      cgst: 0,
      sgst: 0,
      igst: 0,
    };
    formDataItem?.gsttype?.map((item) => {
      Rates[item] = newTax?.[item];
    });

    setformDataItem((prevData) => ({
      ...prevData,
      cgst: newTax?.cgst,
      sgst: newTax?.sgst,
      igst: newTax?.igst,
      totalgst: Rates.cgst + Rates.sgst + Rates.igst,
      gstper: Rates.cgst + Rates.sgst + Rates.igst,
    }));
    calculateFormDataAmount(TotalQuantity, Number(value), DiscountPer, isDisAmt, Rates);
  };

  const handleDiscountPer = (event) => {
    let DisPer = event.target.value;
    setDiscountPer(DisPer);
    setformDataItem((prevData) => ({ ...prevData, discount_per: DisPer }));

    let newTax = TaxRanges?.find((item) => {
      return DiscountedRate(DsgRate, DisPer) >= item?.from && DiscountedRate(DsgRate, DisPer) <= item?.to
    })

    let Rates = {
      cgst: 0,
      sgst: 0,
      igst: 0,
    };
    formDataItem?.gsttype?.map((item) => {
      Rates[item] = newTax?.[item];
    });

    setformDataItem((prevData) => ({
      ...prevData,
      cgst: newTax?.cgst,
      sgst: newTax?.sgst,
      igst: newTax?.igst,
      totalgst: Rates.cgst + Rates.sgst + Rates.igst,
      gstper: Rates.cgst + Rates.sgst + Rates.igst,
    }));
    calculateFormDataAmount(TotalQuantity, DsgRate, DisPer, isDisAmt, Rates);
  };

  const handleDiscountAmt = (event) => {
    let DisAmt = event.target.value;
    setDiscountAmt(DisAmt);
    setformDataItem((prevData) => ({ ...prevData, discount_amount: DisAmt }));

    let disPerr = (DisAmt / AmountBFT) * 100;
    let disPer = disPerr == Infinity ? 0 : disPerr?.toFixed(2);
    let newTax = TaxRanges?.find((item) => {
      return DiscountedRate(DsgRate, disPer) >= item?.from && DiscountedRate(DsgRate, disPer) <= item?.to
    })

    let Rates = {
      cgst: 0,
      sgst: 0,
      igst: 0,
    };
    formDataItem?.gsttype?.map((item) => {
      Rates[item] = newTax?.[item];
    });

    setformDataItem((prevData) => ({
      ...prevData,
      cgst: newTax?.cgst,
      sgst: newTax?.sgst,
      igst: newTax?.igst,
      totalgst: Rates.cgst + Rates.sgst + Rates.igst,
      gstper: Rates.cgst + Rates.sgst + Rates.igst,
    }));
    calculateFormDataAmount(TotalQuantity, DsgRate, DisAmt, isDisAmt, Rates);
  };


  const calculateFormDataAmount = (Qty, Rate, Discount, isDisAmt, gstRates) => {
    let TotalQ = Qty;
    setTotalQuantity(TotalQ);
    let AmountBf = (TotalQ ? TotalQ : 0) * (Rate ? Rate : 0);
    if (isDisAmt) {
      var DisPer = (Discount / AmountBf) * 100;
      setDiscountPer(DisPer == Infinity ? 0 : DisPer?.toFixed(2));
      var DisAmt = Discount;
    } else {
      var DisAmt = AmountBf * (Discount ? Discount / 100 : 0);
      setDiscountAmt(Number(DisAmt)?.toFixed(2));
    }

    AmountBf = AmountBf - DisAmt;
    setAmountBFT(AmountBf?.toFixed(2));

    setGstRates(gstRates);
    let cgstVal = AmountBf * ((gstRates?.cgst ? gstRates?.cgst : 0) / 100);
    let sgstVal = AmountBf * ((gstRates?.sgst ? gstRates?.sgst : 0) / 100);
    let igstVal = AmountBf * ((gstRates?.igst ? gstRates?.igst : 0) / 100);
    setcgstValue(cgstVal?.toFixed(2));
    setsgstValue(sgstVal?.toFixed(2));
    setigstValue(igstVal?.toFixed(2));
    const itemTotAmt =
      Number(AmountBf) + Number(cgstVal) + Number(sgstVal) + Number(igstVal);
    setitemTotalAmt(itemTotAmt?.toFixed(2));
  };

  const updatePackingChallan = async () => {
    if (!BillNo) {
      return showToast("Please Enter Bill No.", "error");
    } else if (!BillDate) {
      return showToast("Please Enter Bill Date", "error");
    }

    setLoader(true);
    var myHeaders = new Headers();
    myHeaders.append("Access-Control-Allow-Origin", "*");
    myHeaders.append("Content-Type", "application/json");

    var rawData = CustomStringify({
      et_ledger_id: 0,
      supplierId: Led_ID?.value,
      party: Led_ID?.label,
      supplier_name: Led_ID?.label,
      address: Led_ID?.address,
      mobile_no: Led_ID?.mobile_no,
      GSTIN: Led_ID?.GSTIN,
      PINCode: Led_ID?.PINCode,
      et_state_id: Led_ID?.et_state_id,
      state: Led_ID?.state,
      et_city_id: Led_ID?.et_city_id,
      city: Led_ID?.city,
      et_broker_id: Led_ID?.et_broker_id,
      broker: Led_ID?.broker,
      bill_no: BillNo,
      bill_date: BillDate,
      et_transport_id: Trp_ID?.value,
      transport: Trp_ID?.label,
      total_quantity: mainTotalQty,
      discount_amount: mainTotalDiscount,
      totalAmount: mainTotalTaxableAmt,
      gst_amount: Number(mainTotalItemCgst) + Number(mainTotalItemSgst) + Number(mainTotalItemIgst),
      net_amount: mainTotalAmount,
      // is_cancel: isCancle,
      OrderDesign: itemDataArray,
      orderId: 0,
      orderdate: 0,
      order_no: 0,
    });

    var requestOptions = {
      method: "PATCH",
      headers: myHeaders,
      body: rawData,
      redirect: "follow",
    };

    fetch(`${API_URL}/purchase/${cmpdetail?.key}/${id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.success === true) {
          setLoader(false);
          navigate("/PackingChallan", {
            state: "Packing challan Updated Successfully",
          });
        } else {
          setLoader(false);
          showToast(result?.message, "error");
        }
      })
      .catch((error) => {
        setLoader(false);
        showToast("API Error", "error");
        console.log(error);
      });
  };

  const ClrSizehandler = async (event) => {
    const { name, value } = event.target;
    const [colorName, sizename] = name.split(".");

    let newRawClrSize = RawClrSize.map((elem) => {
      if (elem?.color_name == colorName) {
        return {
          ...elem,
          sizes: elem?.sizes?.map((ele) => {
            if (ele?.size_name == sizename) {
              return {
                ...ele,
                qty: Number(value),
              };
            } else {
              return ele;
            }
          }),
        };
      } else {
        return elem;
      }
    });

    setRawClrSize(newRawClrSize);

    let Qty = newRawClrSize?.reduce((acc, item) => {
      let newac = item?.sizes?.reduce((ac, elem) => {
        return ac + Number(elem?.qty || 0);
      }, 0)

      return acc + newac
    }, 0);

    calculateFormDataAmount(Qty, DsgRate, DiscountPer, isDisAmt, GstRates);
  };

  const setMainTotalData = () => {
    var mainTotQty = 0;
    var mainTotDis = 0;
    var mainTotTaxAmt = 0;
    var mainTotItemCgst = 0;
    var mainTotItemSgst = 0;
    var mainTotItemIgst = 0;
    var mainTotAmt = 0;

    itemDataArray?.filter((item) => !item?.is_cancel)?.map((item) => {
      mainTotQty = mainTotQty + Number(item?.qty);
      mainTotDis = mainTotDis + Number(item?.discount_amount);
      mainTotTaxAmt = mainTotTaxAmt + Number(item?.amountbft);
      mainTotItemCgst = mainTotItemCgst + Number(item?.cgstamt);
      mainTotItemSgst = mainTotItemSgst + Number(item?.sgstamt);
      mainTotItemIgst = mainTotItemIgst + Number(item?.igstamt);
      mainTotAmt = mainTotAmt + Number(item?.amount);
    });

    setMainTotalQty(mainTotQty?.toFixed(2));
    setMainTotalDiscount(mainTotDis?.toFixed(2));
    setMainTotalTaxableAmt(mainTotTaxAmt?.toFixed(2));
    setMainTotalItemCgst(mainTotItemCgst?.toFixed(2));
    setMainTotalItemSgst(mainTotItemSgst?.toFixed(2));
    setMainTotalItemIgst(mainTotItemIgst?.toFixed(2));
    setMainTotalAmount(mainTotAmt?.toFixed(2));
  };

  const MakeColorsArr = (arr, clrsize) => {
    if (clrsize) {
      return arr?.map((item) => {
        if (item?.sizes?.reduce((acc, el) => {
          return acc + Number(el?.qty || 0)
        }, 0) > 0) {
          return {
            ...item,
            qty: item?.sizes?.reduce((acc, el) => {
              return acc + Number(el?.qty || 0)
            }, 0),
            orderDetailId: item?.orderDetailId || 0,
            sizes: item?.sizes?.map((elem) => {
              if (elem?.qty) {
                return {
                  ...elem,
                  size_dtltlb_id: elem?.size_dtltlb_id || 0,
                }
              } else {
                return null
              }
            })?.filter((e) => e != null)
          }
        } else {
          return null
        }
      })?.filter((e) => e != null)
    } else {
      if (isEditItemForm) {
        return formDataItem?.colors?.map((item) => {
          return {
            ...item,
            qty: TotalQuantity,
            orderDetailId: item?.orderDetailId || 0,
            sizes: item?.sizes?.map((elem) => {
              return {
                ...elem,
                qty: TotalQuantity,
                size_dtltlb_id: elem?.size_dtltlb_id || 0,
              }
            })
          }
        })
      } else {
        return [
          {
            "designId": 84,
            "supply_design": SuppDsgnNmCD?.label,
            "design_no": SuppDsgnNmCD?.design_no,
            "product": SuppDsgnNmCD?.product,
            "colorId": 0,
            "color_name": "Mix",
            "et_color_id": 0,
            "qty": TotalQuantity,
            "orderDetailId": 0,
            "sizes": [
              {
                "sizeId": 1,
                "size_name": "No Size",
                "et_size_id": 0,
                "qty": TotalQuantity,
                "size_dtltlb_id": 0,
              }
            ],
          }
        ]
      }
    }
  }

  const handleAddItemDetail = (id, Qty, Rate) => {
    if (Qty) {
      if (Rate) {
        if (Number(cgstValue) || Number(sgstValue) || Number(igstValue)) {
          setitemDataArray((prevArray) => [
            ...prevArray,
            {
              ...formDataItem,
              colors: MakeColorsArr(RawClrSize, RawClrSize?.length > 0 && IsClrSize)
            },
          ]);
          setRowId(id + 1);
          emptyFormData();
          setMainTotalData();
        } else {
          showToast("GST Not Found", "error");
        }
      } else {
        showToast("Please Add Rate", "error");
      }
    } else {
      showToast("Please Add Quantity", "error");
    }
  };

  const handleUpdateItemDetail = (index, Qty, Rate) => {
    if (Qty) {
      if (Rate) {
        if (Number(cgstValue) || Number(sgstValue) || Number(igstValue)) {
          setitemDataArray((prevArray) => [
            ...prevArray?.filter((item, i) => i != index),
            {
              ...formDataItem,
              colors: MakeColorsArr(RawClrSize, RawClrSize?.length > 0 && IsClrSize)
            },
          ]);
          emptyFormData();
          setMainTotalData();
          setIsEditItemForm(false);
          setIsClrSize(false);
          handleModalClose();
        } else {
          showToast("GST Not Found", "error");
        }
      } else {
        showToast("Please Add Rate", "error");
      }
    } else {
      showToast("Please Add Quantity", "error");
    }
  };

  useEffect(() => {
    setMainTotalData();
  }, [itemDataArray]);

  useEffect(() => {
    setformDataItem((prevData) => ({
      ...prevData,
      design_id: SuppDsgnNmCD?.value != undefined ? SuppDsgnNmCD?.value : "",
    }));
    setformDataItem((prevData) => ({
      ...prevData,
      product_id: PodIdNme?.value != undefined ? PodIdNme?.value : "",
    }));
    setformDataItem((prevData) => ({
      ...prevData,
      hsn_code: ProductHSN != undefined ? ProductHSN : "",
    }));
    setformDataItem((prevData) => ({
      ...prevData,
      qty: TotalQuantity != undefined ? TotalQuantity : "",
    }));
    setformDataItem((prevData) => ({
      ...prevData,
      rate: DsgRate != undefined ? DsgRate : "",
    }));
    setformDataItem((prevData) => ({
      ...prevData,
      discount_per: DiscountPer != undefined ? DiscountPer : "",
    }));
    setformDataItem((prevData) => ({
      ...prevData,
      discount_amount: DiscountAmt != undefined ? DiscountAmt : "",
    }));
    setformDataItem((prevData) => ({
      ...prevData,
      amountbft: AmountBFT != undefined ? AmountBFT : "",
    }));
    setformDataItem((prevData) => ({
      ...prevData,
      cgstamt: cgstValue != undefined ? cgstValue : "",
    }));
    setformDataItem((prevData) => ({
      ...prevData,
      sgstamt: sgstValue != undefined ? sgstValue : "",
    }));
    setformDataItem((prevData) => ({
      ...prevData,
      igstamt: igstValue != undefined ? igstValue : "",
    }));
    setformDataItem((prevData) => ({
      ...prevData,
      amount: itemTotalAmt != undefined ? itemTotalAmt : "",
    }));
  }, [
    SuppDsgnNmCD,
    PodIdNme,
    ProductHSN,
    TotalQuantity,
    DsgRate,
    DiscountPer,
    DiscountAmt,
    AmountBFT,
    cgstValue,
    sgstValue,
    igstValue,
    itemTotalAmt,
  ]);

  const sizeName = (id) => {
    let name = SizeAll?.filter((item) => {
      return item?.SizeId == id;
    })[0]?.SizeCode;
    return id == 0 ? "Mix" : name ? name : "";
  };

  const colorName = (id) => {
    let name = ColorAll?.filter((item) => {
      return item?.mstcolour_id == id;
    })[0]?.mstcolour_name;
    return name ? name : "";
  };

  const unitName = (id) => {
    let name = UnitNameList?.filter((item) => {
      return item?.UnitId == id;
    })[0]?.UnitName;
    return name ? name : "";
  };

  const szId = (name) => {
    let id = SizeAll?.filter((item) => {
      return item?.SizeCode == name;
    })[0]?.SizeId;
    return name == "Mix" ? 0 : id ? id : "";
  };

  const clrId = (name) => {
    let id = ColorAll?.filter((item) => {
      return item?.mstcolour_name == name;
    })[0]?.mstcolour_id;
    return id ? id : "";
  };

  const IsMtrs = (id) => {
    let mtrs =
      UnitNameList?.filter((item) => {
        return item?.UnitId == id;
      })[0]?.Unit_UQId == 24;
    return mtrs;
  };

  useEffect(() => {
    getPackingChallanById();
  }, [status]);

  useEffect(() => {
    dispatch(fetchDataPK({ cmpdetail, UserDetail }));
    dispatch(fetchListAC(cmpdetail));
    dispatch(fetchListAgent(cmpdetail));
    dispatch(fetchListTrans(cmpdetail));
    dispatch(fetchListTMBR(cmpdetail));
    dispatch(fetchListSUPFG({ cmpdetail, UserDetail }));
    dispatch(fetchListFG(cmpdetail));
    setLed_ID({
      value: UserDetail?.result?.user?.id,
      label: UserDetail?.result?.user?.company_name
    });
    setTrp_ID({
      value: UserDetail?.result?.user?.et_transport_id,
      label: UserDetail?.result?.user?.transport
    });

    setShouldReRender(true);
    setTimeout(() => setShouldReRender(false), 1);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      function focusNextEmptyInput(currentIndex, inputs) {
        for (let i = currentIndex + 1; i < inputs.length; i++) {
          if (!inputs[i].value) {
            inputs[i].focus();
            return;
          }
        }
      }

      var inputs = document.querySelectorAll("input:enabled");

      inputs.forEach((input, index) => {
        input.addEventListener("focus", function (event) {
          if (event.target.type == "checkbox") {
            var nextIndex = index + 1;
            if (nextIndex < inputs?.length) {
              inputs[nextIndex].focus();
            }
          }
        });
        input.addEventListener("keydown", function (event) {
          if (event.key === "Enter") {
            event.preventDefault();
            if (event.target.id == "Discount%" || (event.target.id == "Rate" && document.getElementById("Discount%")?.value) || (event.target.id == "Qty" && document.getElementById("Rate")?.value && document.getElementById("Discount%")?.value)) {
              itemButton?.focus();
            } else if (event.target.id.indexOf("Autocomplete") == -1) {
              focusNextEmptyInput(index, inputs);
            } else {
              if (event.target.ariaExpanded == "false") {
                focusNextEmptyInput(index, inputs);
              }
            }
          }
        });
      });
    }, 500);
  });

  useEffect(() => {
    const keyEnter = (event) => {
      if (event.altKey) {
        event.preventDefault();
        switch (event.key) {
          case "n":
            handleModalOpen();
            break;
          case "a":
            if (isEditItemForm) {
              handleUpdateItemDetail(itemIndex, TotalQuantity, DsgRate);
            } else {
              handleAddItemDetail(rowId, TotalQuantity, DsgRate);
            }
            break;
          case "s":
            updatePackingChallan();
            break;
          case "e":
            handleModalClose();
            break;
          case "p":
            handlePrintReport(true);
            break;
          default:
            break;
        }
      } else if (event.key == "F10") {
        event.preventDefault();
        handlePrintReport(true);
      }
    };

    document.addEventListener("keydown", keyEnter);

    return () => {
      document.removeEventListener("keydown", keyEnter);
    };
  });

  const exportToExcel = () => {
    const csvData =
      "Supply Design,Design,Product,Qty,Rate,Discount Amt.,Amount BFT,Total Amt.,Color-Size\n" +
      PackingChallanData?.OrderDesign
        ?.map((row) => {
          let str = "";
          if (row?.colors?.length > 0) {
            row?.colors?.map((item) => {
              str += item?.color_name;
              str += " (";
              item?.sizes?.map((elem) => {
                str += elem?.size_name;
                str += ",";
              });
              let ind = str.lastIndexOf(",");
              str = str.slice(0, ind) + str.slice(ind + 1);
              str += ")-(";
              item?.sizes?.map((elem) => {
                str += elem?.qty;
                str += ",";
              });
              let ind2 = str.lastIndexOf(",");
              str = str.slice(0, ind2) + str.slice(ind2 + 1);
              str += ") ";
            });
          } else {
            str += ``;
          }

          let disRate = (Number(row?.discount_per) / 100) * Number(row?.rate);
          let discountedRate = Number(row?.rate) - ((Number(row?.discount_per) / 100) * Number(row?.rate));

          return `"${row.supply_design}","${row.design_no}","${row.product}","${row.qty}","${row.rate}","${disRate * (row.qty)}","${discountedRate * (row.qty)}","${(discountedRate * (row.qty)) + (discountedRate * (row.qty) * (row.totalgst) / 100)}","${str}"`;
        })
        .join("\n");
    // Step 2: Create a Blob object containing the CSV data
    const blob = new Blob([csvData], { type: "text/csv" });
    // Step 3: Create a URL for the Blob and trigger the download
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "PackingChallan.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  // const MergeData = (ItemArray) => {
  //   const mergedArray = ItemArray.reduce(
  //     (accumulator, current) => {
  //       const existing = accumulator.find(
  //         (item) =>
  //           (item.design_no === current.design_no) &&
  //           (item.product === current.product) &&
  //           (item.rate === current.rate)
  //       );

  //       if (existing) {
  //         existing.qty += Number(current.qty);
  //         existing.cgstamt += ((Number(current?.qty) * Number(current?.rate)) * ((current?.gsttype?.includes("cgst") ? current?.cgstamt : 0) / 100));
  //         existing.sgstamt += ((Number(current?.qty) * Number(current?.rate)) * ((current?.gsttype?.includes("sgst") ? current?.sgstamt : 0) / 100));
  //         existing.igstamt += ((Number(current?.qty) * Number(current?.rate)) * ((current?.gsttype?.includes("igst") ? current?.igstamt : 0) / 100));
  //         existing.amountbft += (Number(current?.qty) * Number(current?.rate));

  //       } else {
  //         accumulator.push({ ...current });
  //       }

  //       return accumulator;
  //     },
  //     []
  //   );
  //   return mergedArray;
  // }

  const printRef = useRef();
  const PrintReportRef = useRef(null);
  const printRefFN = useRef(null);

  const handlePrintReport = () => {
    if (PrintReportRef.current) {
      PrintReportRef.current.printReport();
    }
  };

  const handlePrintReportFN = () => {
    if (PrintReportRef.current) {
      PrintReportRef.current.printReportFN();
    }
  };

  const theme = createTheme({
    palette: {
      primary: {
        main: Theme.primaryThemeColor,
      },
    },
    typography: {
      fontFamily: "Poppins",
      h6: {
        "@media (max-width: 450px)": {
          fontSize: "16px",
        },
      }
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            color: "#fff",
            fontSize: "12.5px",
            maxWidth: "260px",
            height: "16px",
            padding: "12px 8px 11px 8px",
            fontWeight: 500,
            "@media (max-width: 450px)": {
              fontSize: "11px",
              padding: "11px 6px 10px 6px",
            },
          },
        },
      },
    },
  });

  const form = createTheme({
    palette: {
      primary: {
        main: Theme.primaryThemeColor,
      },
    },
    typography: {
      fontFamily: "Poppins",
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontSize: "13px",
            height: "35px",
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            fontSize: "14px",
            marginTop: "-8px",
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          input: {
            marginTop: "-8px",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            color: "#fff",
            fontSize: "12.5px",
            maxWidth: "260px",
            height: "35px",
            padding: "0px 8px 0px 8px",
            fontWeight: 500,
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          root: {
            padding: 0,
            minHeight: 30,
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            fontSize: "13px",
            fontWeight: 500,
            padding: 0,
            minHeight: 30,
            "&.Mui-selected": {
              backgroundColor: Theme.primaryThemeColor,
              color: "white",
              borderRadius: "5px",
            },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            borderBottom: "1px solid #9a9da1",
          },
          head: {
            "&::after": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: hexToRGBFade(Theme.primaryThemeColor, 0.4),
              zIndex: -1,
            },
            whiteSpace: "nowrap",
            width: "auto",
          },
          body: {
            whiteSpace: "nowrap",
            width: "auto",
          },
        },
      },
    },
  });

  const innerformClr = createTheme({
    palette: {
      primary: {
        main: Theme.primaryThemeColor,
      },
    },
    typography: {
      fontFamily: "Poppins",
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontSize: "13px",
            height: "30px",
            width: "100px",
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            marginTop: "-10px",
            fontSize: "14px"
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          input: {
            marginTop: "-5px",
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            fontWeight: "600",
            fontSize: "14px",
          },
        },
      },
    },
  });
  useEffect(() => {
    dispatch(fetchBarcodePrintSetting());
  }, [dispatch]);
  useEffect(() => {
    // 9 for every where print 
    // 8 for only print on only packingChallan 
    // 7 for only print on only Design 
    if (BarcodeRateSetting?.cmpdetail) {
      if ((BarcodeRateSetting?.cmpdetail?.barcode_print_option == 9) || (BarcodeRateSetting?.cmpdetail?.barcode_print_option == 8)) {
        setIsBarcodePrint(true)
      } else {
        setIsBarcodePrint(false)
      }
    }
  }, [BarcodeRateSetting])
  return (
    <>
      <PrintReport TxnName={"PackingChallan"} printRef={printRef} Led_Whatsaap={""} Led_Email={""} SONO={SONO} EmailBSMSDetails={""} handleModalCloseEmail={null} Brok_Whatsapp={""} handleModalCloseBSMS={null} printRefFN={printRefFN} ref={PrintReportRef} />

      <div className="print-box" ref={printRef} style={{ display: "none" }}>
        <div className="container-fluid mt-3 print-only">
          <h2
            style={{
              fontFamily: "Poppins",
              fontSize: 22,
              color: "#000",
              fontWeight: 600,
              textAlign: "center"
            }}
          >
            {UserDetail?.result?.user?.company_name}
          </h2>
          <div className="d-flex" style={{ width: "100%", alignItems: "center" }}>
            <div style={{ width: "33%", textAlign: "start" }}>
              {/* <img src={cmpdetail?.logoImg} alt="logo" style={{ width: "90%" }} /> */}
            </div>
            <div style={{ width: "33%", textAlign: "center" }}>
              <h6
                style={{
                  fontFamily: "Poppins",
                  fontSize: 14,
                  color: "#000",
                  fontWeight: 500,
                }}
              >
                {UserDetail?.result?.user?.address ? UserDetail?.result?.user?.address + "," : null}{" "}
                {UserDetail?.result?.user?.state} {UserDetail?.result?.user?.city} ({UserDetail?.result?.user?.pin_code})
              </h6>
              <h6
                style={{
                  fontFamily: "Poppins",
                  fontSize: 14,
                  color: "#000",
                  fontWeight: 500,
                }}
              >
                {UserDetail?.result?.user?.mobile_no}{" "}
                {/* {UserDetail?.result?.user?.Contactno ? ", " + UserDetail?.result?.user?.Contactno : ""} */}
              </h6>
              <h6
                style={{
                  fontFamily: "Poppins",
                  fontSize: 14,
                  color: "#000",
                  fontWeight: 500,
                }}
              >
                {UserDetail?.result?.user?.Email}
              </h6>
              <div
                style={{
                  fontFamily: "Poppins",
                  fontSize: 13,
                  color: "#000",
                  fontWeight: 600,
                }}
              >
                GSTNo. {UserDetail?.result?.user?.GSTIN}
              </div>
              <h6
                style={{
                  fontFamily: "Poppins",
                  fontSize: 15,
                  color: "#000",
                  fontWeight: 600,
                  margin: "5px 0 5px 0",
                }}
              >
                TAX CHALLAN
              </h6>
            </div>
            <div style={{ width: "33%", textAlign: "end" }}>
              &nbsp;
              {/* <img src={cmpdetail?.logoImg} alt="logo" style={{ width: "90%" }} /> */}
            </div>
          </div>

          <div className="row mt-2 g-0" style={{ border: "1px solid #000" }}>
            <div className="col-6" style={{ borderRight: "1px solid #000" }}>
              <div className="box rounded-0 p-1 bg-transparent">
                <div className="row">
                  <div
                    className="col-3"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 12,
                      color: "#000",
                      fontWeight: 500,
                      paddingRight: 0
                    }}
                  >
                    Challan No.
                  </div>
                  <div
                    className="text-start col-5"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 12,
                      color: "#000",
                      fontWeight: 600,
                      paddingLeft: 0,
                      paddingRight: 0
                    }}
                  >
                    :&nbsp; {PackingChallanData?.purchase_no}
                  </div>
                  <div
                    className="col-1"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 12,
                      color: "#000",
                      fontWeight: 500,
                      paddingLeft: 0,
                      paddingRight: 0
                    }}
                  >
                    Date
                  </div>
                  <div
                    className="text-start col-3"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 11.5,
                      color: "#000",
                      fontWeight: 600,
                      paddingLeft: 0,
                      paddingRight: 0
                    }}
                  >
                    :&nbsp;{" "}
                    {DateToShow(PackingChallanData?.createdAt)}
                  </div>
                  <div
                    className="col-3"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 12,
                      color: "#000",
                      fontWeight: 500,
                      paddingRight: 0
                    }}
                  >
                    Bill No.
                  </div>
                  <div
                    className="text-start col-4"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 12,
                      color: "#000",
                      fontWeight: 600,
                      paddingLeft: 0,
                      paddingRight: 0
                    }}
                  >
                    :&nbsp; {PackingChallanData?.bill_no}
                  </div>
                  <div
                    className="col-2"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 12,
                      color: "#000",
                      fontWeight: 500,
                      paddingLeft: 0,
                      paddingRight: 0
                    }}
                  >
                    Bill Date
                  </div>
                  <div
                    className="text-start col-3"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 11.5,
                      color: "#000",
                      fontWeight: 600,
                      paddingLeft: 0,
                      paddingRight: 0
                    }}
                  >
                    :&nbsp;{" "}
                    {DateToShow(PackingChallanData?.bill_date)}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="box rounded-0 p-1 border-0 bg-transparent">
                <div className="row">
                  <div
                    className="col-3"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 12,
                      color: "#000",
                      fontWeight: 500,
                      paddingRight: 0
                    }}
                  >
                    Agent
                  </div>
                  <div
                    className="text-start col-9"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 12,
                      color: "#000",
                      fontWeight: 600,
                      paddingLeft: 0,
                      paddingRight: 0
                    }}
                  >
                    :&nbsp; {PackingChallanData?.broker}
                  </div>
                  <div
                    className="col-3"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 12,
                      color: "#000",
                      fontWeight: 500,
                      paddingRight: 0
                    }}
                  >
                    Transport
                  </div>
                  <div
                    className="text-start col-9"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 12,
                      color: "#000",
                      fontWeight: 600,
                      paddingLeft: 0,
                      paddingRight: 0
                    }}
                  >
                    :&nbsp; {PackingChallanData?.transport}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row g-0">
            <div
              className="col-12"
              style={{
                borderLeft: "1px solid #000",
                borderRight: "1px solid #000",
                textAlign: "center",
              }}
            >
              <div className="box rounded-0 p-1 bg-transparent">
                <div
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 12,
                    color: "#000",
                    fontWeight: 600,
                  }}
                >
                  Details of Receiver | Billed To
                </div>
              </div>
            </div>
          </div>
          <div
            className="row g-0"
            style={{
              border: "1px solid #000",
              borderBottom: "0px solid #000",
            }}
          >
            <div className="col-12">
              <div className="box rounded-0 p-1 bg-transparent border-0">
                <div className="row">
                  <div
                    className="col-2"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 12,
                      color: "#000",
                      fontWeight: 500,
                      paddingRight: 0
                    }}
                  >
                    Name
                  </div>
                  <div
                    className="text-start col-10"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 14,
                      color: "#000",
                      fontWeight: 600,
                      paddingLeft: 0,
                      paddingRight: 0
                    }}
                  >
                    :&nbsp;{PackingChallanData?.is_cancel ? "" : cmpdetail?.company_name}
                  </div>
                </div>
                <div className="row">
                  <div
                    className="col-2"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 12,
                      color: "#000",
                      fontWeight: 500,
                      paddingRight: 0
                    }}
                  >
                    Address
                  </div>
                  <div
                    className="text-start col-10"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 12,
                      color: "#000",
                      fontWeight: 600,
                      paddingLeft: 0,
                      paddingRight: 0
                    }}
                  >
                    :&nbsp; {PackingChallanData?.is_cancel ? "" : `${cmpdetail?.Address ? cmpdetail?.Address + "," : null} ${cmpdetail?.city} ${cmpdetail?.pin_code ? ", " + cmpdetail?.pin_code : null}`}
                  </div>
                  <div
                    className="col-2"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 12,
                      color: "#000",
                      fontWeight: 500,
                      paddingRight: 0
                    }}
                  >
                    Mobile No.
                  </div>
                  <div
                    className="text-start col-10"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 12,
                      color: "#000",
                      fontWeight: 600,
                      paddingLeft: 0,
                      paddingRight: 0
                    }}
                  >
                    :&nbsp;{PackingChallanData?.is_cancel ? "" : cmpdetail?.mobile_no}
                  </div>
                  <div
                    className="col-2"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 12,
                      color: "#000",
                      fontWeight: 500,
                      paddingRight: 0
                    }}
                  >
                    GST No.
                  </div>
                  <div
                    className="text-start col-10"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 12,
                      color: "#000",
                      fontWeight: 600,
                      paddingLeft: 0,
                      paddingRight: 0
                    }}
                  >
                    :&nbsp;{PackingChallanData?.is_cancel ? "" : cmpdetail?.gst_no}
                  </div>
                  <div
                    className="col-2"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 12,
                      color: "#000",
                      fontWeight: 500,
                      paddingRight: 0
                    }}
                  >
                    State
                  </div>
                  <div
                    className="text-start col-10"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 12,
                      color: "#000",
                      fontWeight: 600,
                      paddingLeft: 0,
                      paddingRight: 0
                    }}
                  >
                    :&nbsp;{" "}
                    {PackingChallanData?.is_cancel ? "" : cmpdetail?.state}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bill-body">
            <table className="bill-body-table">
              <thead>
                <tr className="table-head">
                  <th className="table-head-text text-end">SN.</th>
                  <th className="table-head-text">Description</th>
                  <th className="table-head-text text-center">HSN</th>
                  <th className="table-head-text text-end">QTY</th>
                  <th className="table-head-text text-end">RATE</th>
                  {mainTotalDiscount > 0 ? (
                    <>
                      <th colspan="2" className="table-head-text text-end">
                        DISCOUNT
                      </th>
                    </>
                  ) : (
                    <></>
                  )}
                  {mainTotalItemCgst > 0 ? (
                    <>
                      <th colspan="2" className="table-head-text text-center">
                        CGST
                      </th>
                      <th colspan="2" className="table-head-text text-center">
                        SGST
                      </th>
                    </>
                  ) : (
                    <th colspan="2" className="table-head-text text-center">
                      IGST
                    </th>
                  )}
                  <th className="table-head-text text-end">AMT BFT</th>
                </tr>
              </thead>
              <tbody>
                {PackingChallanData?.OrderDesign?.map((item, index) => (
                  <tr className="table-body" key={index}>
                    <td className="table-body-text text-end" style={{ width: "30px" }}>
                      {index + 1}
                    </td>
                    <td className="table-body-text">
                      {item?.supply_design} - {item?.product} ({item?.design_no})
                    </td>
                    <td className="table-body-text text-center" style={{ width: "60px" }}>
                      {item?.hsn_code}
                    </td>
                    <td className="table-body-text text-end" style={{ width: "60px" }}>
                      {item?.qty ? item?.qty : null}
                    </td>
                    <td className="table-body-text text-end" style={{ width: "60px" }}>
                      {item?.rate ? item?.rate : null}
                    </td>
                    {mainTotalDiscount > 0 ? (
                      <>
                        <td
                          className="table-body-text text-end"
                          style={{ width: "50px" }}
                        >
                          <b>
                            {item?.discount_per ? item?.discount_per + "%" : ""}
                          </b>
                        </td>
                        <td
                          className="table-body-text text-end"
                          style={{ width: "50px" }}
                        >
                          {item?.discount_amount ? item?.discount_amount : ""}
                        </td>
                      </>
                    ) : (
                      <></>
                    )}
                    {mainTotalItemCgst > 0 ? (
                      <>
                        <td
                          className="table-body-text text-end"
                          style={{ width: "50px" }}
                        >
                          <b>
                            {item?.cgst ? item?.cgst + "%" : ""}
                          </b>
                        </td>
                        <td
                          className="table-body-text text-end"
                          style={{ width: "50px" }}
                        >

                          {((Number(item?.qty) * (Number(item?.rate) - ((Number(item?.discount_per) / 100) * Number(item?.rate)))) * ((item?.gsttype?.includes("cgst") ? item?.cgst : 0) / 100)).toFixed(2)}
                        </td>
                        <td
                          className="table-body-text text-end"
                          style={{ width: "50px" }}
                        >
                          <b>
                            {item?.sgst
                              ? item?.sgst + "%"
                              : ""}
                          </b>
                        </td>
                        <td
                          className="table-body-text text-end"
                          style={{ width: "50px" }}
                        >
                          {((Number(item?.qty) * (Number(item?.rate) - ((Number(item?.discount_per) / 100) * Number(item?.rate)))) * ((item?.gsttype?.includes("sgst") ? item?.sgst : 0) / 100)).toFixed(2)}
                        </td>
                      </>
                    ) : (
                      <>
                        <td
                          className="table-body-text text-end"
                          style={{ width: "50px" }}
                        >
                          <b>
                            {item?.igst
                              ? item?.igst + "%"
                              : ""}
                          </b>
                        </td>
                        <td
                          className="table-body-text text-end"
                          style={{ width: "50px" }}
                        >
                          {((Number(item?.qty) * (Number(item?.rate) - ((Number(item?.discount_per) / 100) * Number(item?.rate)))) * ((item?.gsttype?.includes("igst") ? item?.igst : 0) / 100)).toFixed(2)}
                        </td>
                      </>
                    )}
                    <td
                      className="table-body-text text-end"
                      style={{ width: "80px" }}
                    >
                      {(Number(item?.qty) * (Number(item?.rate) - ((Number(item?.discount_per) / 100) * Number(item?.rate)))).toFixed(2)}
                    </td>
                  </tr>
                ))}
                <tr
                  className="table-body"
                  style={{
                    height: `calc(${"20vh"} - (${"35px"}*${PackingChallanData?.OrderDesign?.length
                      }))`,
                  }}
                >
                  <td className="table-empty-text"></td>
                  <td className="table-empty-text"></td>
                  <td className="table-empty-text"></td>
                  <td className="table-empty-text"></td>
                  <td className="table-empty-text"></td>
                  {mainTotalDiscount > 0 ? (
                    <>
                      <td className="table-empty-text"></td>
                      <td className="table-empty-text"></td>
                    </>
                  ) : (
                    <></>
                  )}
                  {mainTotalItemCgst > 0 ? (
                    <>
                      <td className="table-empty-text"></td>
                      <td className="table-empty-text"></td>
                      <td className="table-empty-text"></td>
                      <td className="table-empty-text"></td>
                    </>
                  ) : (
                    <>
                      <td className="table-empty-text"></td>
                      <td className="table-empty-text"></td>
                    </>
                  )}
                  <td className="table-empty-text"></td>
                </tr>
              </tbody>
              <tfoot>
                <tr className="table-body">
                  <td className="table-head-text text-end"></td>
                  <td className="table-head-text">Total</td>
                  <td className="table-head-text text-center"></td>
                  <td className="table-head-text text-end">
                    {PackingChallanData?.total_quantity}
                  </td>
                  <td className="table-head-text text-end"></td>
                  {mainTotalDiscount > 0 ? (
                    <>
                      <td className="table-head-text text-end"></td>
                      <td className="table-head-text text-end">
                        {mainTotalDiscount}
                      </td>
                    </>
                  ) : (
                    <></>
                  )}
                  {mainTotalItemCgst > 0 ? (
                    <>
                      <td className="table-head-text text-end"></td>
                      <td className="table-head-text text-end">
                        {mainTotalItemCgst}
                      </td>
                      <td className="table-head-text text-end"></td>
                      <td className="table-head-text text-end">
                        {mainTotalItemSgst}
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="table-head-text text-end"></td>
                      <td className="table-head-text text-end">
                        {mainTotalItemIgst}
                      </td>
                    </>
                  )}
                  <td className="table-head-text text-end">
                    {PackingChallanData?.totalAmount}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div className="row g-0">
            <div
              className="col-7 g-0"
              style={{
                border: "1px solid #000",
                borderRight: "0px solid #000",
              }}
            >
              <div className="box rounded-0 bg-transparent col-12 p-1">
                <div
                  className="text-start"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 13,
                    color: "#000",
                    fontWeight: 800,
                  }}
                >
                  Total Amount in Words :{" "}
                  <span
                    className="text-start"
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 13,
                      color: "#000",
                      fontWeight: 500,
                    }}
                  >
                    Rs. {numberToWords(PackingChallanData?.net_amount > 0 ? parseInt(PackingChallanData?.net_amount) : 0)}{" "}
                    Only
                  </span>
                </div>
              </div>
            </div>
            <div className="col-5 g-0">
              <div className="box rounded-0 bg-transparent border-0">
                <table className="bill-body-table bg-light">
                  <tbody>
                    <tr className="table-body">
                      <td className="table-body-text"> Total Amt BFT :</td>
                      <td className="table-body-text text-end">
                        {" "}
                        {PackingChallanData?.totalAmount}
                      </td>
                    </tr>
                    <tr className="table-body">
                      <td className="table-body-text"> Total GST :</td>
                      <td className="table-body-text text-end">
                        {" "}
                        {PackingChallanData?.gst_amount}
                      </td>
                    </tr>
                    <tr className="table-body">
                      <td className="table-body-text"> Net Amount :</td>
                      <td className="table-body-text text-end">
                        {" "}
                        {PackingChallanData?.net_amount}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div
            className="Print-Footer row g-0"
            style={{ border: "1px solid #000", borderTop: "0px solid #000" }}
          >
            <div className="col-7 py-4"></div>
            <div className="col-5 pe-4 text-end">
              <div
                className="pt-2"
                style={{
                  fontFamily: "Poppins",
                  fontSize: 13,
                  color: "#000",
                  fontWeight: 500,
                }}
              >
                For{" "}
                <span
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 14,
                    color: "#000",
                    fontWeight: 600,
                  }}
                >
                  {UserDetail?.result?.user?.company_name}
                </span>
              </div>
              <div
                className="pt-4"
                style={{
                  fontFamily: "Poppins",
                  fontSize: 13,
                  color: "#000",
                  fontWeight: 500,
                }}
              >
                (Authorised Signatory)
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="main-box">
        <ThemeProvider theme={theme}>
          <Typography variant="h6" sx={{ px: 2 }}>{cmpdetail?.company_name}</Typography>
          <div className="box-head transaction-edit">
            <Stack className="heading" alignItems="center" direction="row">
              <IconButton
                color="primary"
                onClick={() => {
                  navigate(-1);
                }}
              >
                <ArrowBackIosIcon sx={{ fontSize: "20px" }} />
              </IconButton>
              <Typography variant="h6">Edit Packing challan</Typography>
            </Stack>
            {isBarcodePrint ? <Stack alignItems="center" direction="row" sx={{ ml: 2 }}>
              <ThemeProvider theme={form}>
                {/* <BarcodePrint allBarcodesData={allBarcodesData} setAllBarcodesData={(newVal) => setAllBarcodesData(newVal)} fieldVal={(content, Barcode_Design, Barcode_DesignID, Rate) => fieldVal(content, Barcode_Design, Barcode_DesignID, Rate)} Txn={true} GetBarcodesById={() => GetBarcodesById()} /> */}
                <NewBarcodePrint
                  allBarcodesData={allBarcodesData}
                  setAllBarcodesData={(newVal) => setAllBarcodesData(newVal)}
                  fieldVal={(content, Barcode_Design, Barcode_DesignID, Rate) => fieldVal(content, Barcode_Design, Barcode_DesignID, Rate)}
                  Txn={true}
                  GetBarcodesById={() => GetBarcodesById()}
                />
              </ThemeProvider>
            </Stack> : null}

            <Stack className="btns" alignItems="center" direction="row">
              <Stack alignItems="center" direction="row" gap={1}>
                <NewBarcodePrint
                  allBarcodesData={allBarcodesData}
                  setAllBarcodesData={(newVal) => setAllBarcodesData(newVal)}
                  fieldVal={(content, Barcode_Design, Barcode_DesignID, Rate) => fieldVal(content, Barcode_Design, Barcode_DesignID, Rate)}
                  Txn={true}
                  GetBarcodesById={() => GetBarcodesById()}
                  PrintFN={true}
                  PackingChallanData={PackingChallanData}
                />
                {/* <BarcodePrint allBarcodesData={allBarcodesData} setAllBarcodesData={(newVal) => setAllBarcodesData(newVal)} fieldVal={(content, Barcode_Design, Barcode_DesignID, Rate) => fieldVal(content, Barcode_Design, Barcode_DesignID, Rate)} Txn={true} GetBarcodesById={() => GetBarcodesById()} PrintFN={true} PackingChallanData={PackingChallanData} /> */}
                <Button
                  onClick={handlePrintReport}
                  variant="contained"
                >
                  Print
                </Button>
              </Stack>
              <Stack alignItems="center" direction="row" gap={1}>
                <Button onClick={exportToExcel} variant="contained">
                  Export
                </Button>
                <Button onClick={updatePackingChallan} variant="contained">
                  Update
                </Button>
              </Stack>
            </Stack>
          </div>
          <Backdrop sx={{ color: "#fff", zIndex: 9999 }} open={Loader}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Dialog
            onClose={handleModalCloseAddNew}
            open={modalOpenAddNew}
            maxWidth={"lg"}
            sx={{
              "& .MuiDialog-paper": {
                width: "100vw",
                mt: -3
              },
            }}
          >
            <DialogTitle sx={{ p: 0, display: "flex", justifyContent: "end" }}>
              <IconButton
                aria-label="close"
                onClick={handleModalCloseAddNew}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent sx={{ p: 0 }}>
              {
                DesignName ?
                  <AddFGDesign Name={DesignName} handleModalCloseAddNew={(event, Desg_ID) => handleModalCloseAddNew(event, Desg_ID)} setLoaderAddNew={(newVal) => setLoader(newVal)} /> :
                  <></>
              }
            </DialogContent>
          </Dialog>
          <DeleteDialog
            modalOpen={modalOpenDelete}
            handleModalClose={() => handleModalCloseDelete()}
            executeConfirmed={() => handleModalOpenPassword()}
          />
          <PasswordDialog
            modalOpen={modalOpenPassword}
            handleModalClose={() => handleModalClosePassword()}
            executeConfirmed={() => deleteFormData(itemIndex)}
          />
          <div className="card-form-box edittxn">
            <ThemeProvider theme={form}>
              <Paper
                sx={{
                  width: "100%",
                  height: "60px",
                  display: "flex",
                  flexDirection: "column",
                  alignContent: "center",
                  overflowY: "scroll",
                  "::-webkit-scrollbar": {
                    display: "none",
                  },
                  py: 1,
                  transition: "0.5s ease-in-out",
                }}
              >
                <Grid
                  container
                  spacing={1.3}
                  columns={12}
                  sx={{ mt: 0.1, width: "100%", padding: "0 10px 0 10px" }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <TextField
                      id="Packing Challan No."
                      label="Packing Challan No."
                      value={SONO}
                      onChange={(event) => {
                        setSONO(event.target.value);
                      }}
                      InputLabelProps={{
                        shrink: SONO != undefined ? true : false,
                      }}
                      InputProps={{ inputProps: { min: 0 } }}
                      type="number"
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <TextField
                      id="BillNo."
                      label="Bill No."
                      value={BillNo}
                      onChange={(event) => {
                        setBillNo(event.target.value);
                      }}
                      InputLabelProps={{
                        shrink: BillNo != undefined ? true : false,
                      }}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        disableFuture
                        // maxDate={dayjs(cmpdetail?.ExpiryDate)}
                        format="DD/MM/YYYY"
                        label="Bill Date"
                        value={BillDate ? dayjs(BillDate) : null}
                        onChange={(newValue) => {
                          return setBillDate(newValue.format("YYYY-MM-DD"));
                        }}
                        InputLabelProps={{
                          shrink: BillDate != undefined ? true : false,
                        }}
                        sx={{ width: "100%" }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    {shouldReRender ? (
                      <Autocomplete
                        disableClearable
                        id="Mui-Autocomplete-TransportName"
                        sx={{ width: "100%" }}
                        renderInput={(params) => (
                          <TextField {...params} label="Transport Name" />
                        )}
                      />
                    ) : null}
                    {!shouldReRender && (
                      <Autocomplete
                        disableClearable
                        id="Mui-Autocomplete-TransportName"
                        value={Trp_ID}
                        onChange={(event, newValue) => {
                          handleTrp_ID(newValue);
                        }}
                        options={transList?.sort(sortByLabel)}
                        renderOption={(props, item) => (
                          <li {...props} key={item.value}>
                            {item.label}
                          </li>
                        )}
                        filterOptions={(options, params) => {
                          const filtered = filter(options, params);
                          if (
                            params.inputValue !== "" &&
                            filtered?.length < 1
                          ) {
                            filtered.push({
                              label: `Add "${params.inputValue}"`,
                              value: 0,
                            });
                          }
                          return filtered;
                        }}
                        getOptionLabel={(option) =>
                          option.label ? option.label : ""
                        }
                        isOptionEqualToValue={(option, value) =>
                          option?.value === value?.value
                        }
                        sx={{ width: "100%" }}
                        renderInput={(params) => (
                          <TextField {...params} label="Transport Name" />
                        )}
                      />
                    )}
                  </Grid>
                </Grid>
              </Paper>
              <Box
                sx={{
                  width: "100%",
                  height: "calc(100% - 60px)",
                  bgcolor: "background.paper",
                  transition: "0.5s ease-in-out",
                }}
              >
                <TabContext value={tabValue}>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <TabList
                      onChange={handleTabChange}
                      variant="fullWidth"
                      aria-label="lab API tabs example"
                      sx={{ background: "#eaebee" }}
                    >
                      <Tab label="Item Detail" value="1" />
                      {/* <Tab label="Sundry Detail" value="2" /> */}
                    </TabList>
                  </Box>
                  <TabPanel value="1" sx={{ height: "100%", m: 0, p: 0 }}>
                    <TableContainer component={Paper} sx={{ maxHeight: "96%" }}>
                      <Table
                        stickyHeader
                        sx={{ minWidth: 650 }}
                        size="small"
                        aria-label="a dense table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 600 }}>
                              <Tooltip title="Add Item">
                                <IconButton
                                  aria-label="Add"
                                  color="primary"
                                  onClick={handleModalOpen}
                                  sx={{ padding: 0, margin: 0 }}
                                >
                                  <AddCircleOutlinedIcon
                                    sx={{ fontSize: "20px" }}
                                  />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>SR#</TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>
                              Supply Design
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>
                              Design
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>
                              Product
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>Qty</TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>Rate</TableCell>
                            <TableCell colSpan={2} align="center" sx={{ fontWeight: 600 }} >
                              Discount
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>
                              Taxable Amt
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {itemDataArray?.map((item, index) => ({ ...item, originalIndex: index }))?.filter((item) => !item?.is_cancel)?.map((item, index) => (
                            <TableRow key={index}>
                              <TableCell sx={{ py: 0.5 }}>
                                <Tooltip title="Edit Item">
                                  <IconButton
                                    color="primary"
                                    aria-label="Edit"
                                    onClick={() => {
                                      handleModalEdit(item, item?.originalIndex);
                                    }}
                                    sx={{ padding: 0, margin: 0 }}
                                  >
                                    <ModeEditIcon sx={{ fontSize: "20px" }} />
                                  </IconButton>
                                </Tooltip>
                              </TableCell>
                              <TableCell sx={{ py: 0.5 }}>
                                {index + 1}
                              </TableCell>
                              <TableCell sx={{ py: 0.5 }}>
                                {item?.supply_design}
                              </TableCell>
                              <TableCell sx={{ py: 0.5 }}>
                                {item?.design_no}
                              </TableCell>
                              <TableCell sx={{ py: 0.5 }}>
                                {item?.product}
                              </TableCell>
                              <TableCell sx={{ py: 0.5 }}>
                                {item?.qty}
                              </TableCell>
                              <TableCell sx={{ py: 0.5 }}>
                                {item?.rate}
                              </TableCell>
                              <TableCell align="center" sx={{ py: 0.5 }}>
                                <b>
                                  {item?.discount_per
                                    ? item?.discount_per + "%"
                                    : ""}
                                </b>
                              </TableCell>
                              <TableCell align="center" sx={{ py: 0.5 }}>
                                {item?.discount_amount
                                  ? item?.discount_amount
                                  : ""}
                              </TableCell>
                              <TableCell sx={{ py: 0.5 }}>
                                {item?.amountbft}
                              </TableCell>
                              <TableCell sx={{ py: 0.5 }}>
                                <Tooltip title="Delete Item">
                                  <IconButton
                                    color="primary"
                                    aria-label="Delete"
                                    onClick={() => {
                                      handleModalOpenDelete(item?.originalIndex, 1);
                                    }}
                                    sx={{ padding: 0, margin: 0 }}
                                  >
                                    <DeleteIcon sx={{ fontSize: "20px" }} />
                                  </IconButton>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <Dialog
                      onClose={handleModalClose}
                      open={modalOpen}
                      maxWidth={"lg"}
                      sx={{
                        "& .MuiDialog-paper": {
                          marginTop: "-3vh",
                        },
                      }}
                    >
                      <IconButton
                        aria-label="close"
                        onClick={handleModalClose}
                        sx={{ position: "absolute", top: 0.1, right: 0.1 }}
                      >
                        <CloseIcon />
                      </IconButton>
                      <div className="d-flex justify-content-between align-items-center">
                        <DialogTitle sx={{ pb: 0 }}>
                          Packing Challan
                        </DialogTitle>
                        <DialogTitle sx={{ pb: 0, mr: 2, display: "flex" }}>
                          {SuppDsgnNmCD && !isEditItemForm ? (
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={IsClrSize}
                                  onChange={handleSwitchClrSize}
                                  inputProps={{
                                    "aria-label": "controlled",
                                  }}
                                />
                              }
                              label="Add Colour/Size"
                            />
                          ) : (
                            <></>
                          )}
                          <Button
                            variant="contained"
                            sx={{ marginX: 1 }}
                            onClick={emptyFormData}
                          >
                            Clear
                          </Button>
                          {isEditItemForm ? (
                            <Button
                              id="itemButton"
                              variant="contained"
                              sx={{ marginX: 1 }}
                              onClick={() => {
                                return handleUpdateItemDetail(
                                  itemIndex,
                                  // TotalMeters,
                                  TotalQuantity,
                                  DsgRate
                                );
                              }}
                            >
                              Save
                            </Button>
                          ) : (
                            <Button
                              id="itemButton"
                              variant="contained"
                              sx={{ marginX: 1 }}
                              onClick={() => {
                                return handleAddItemDetail(
                                  rowId,
                                  TotalQuantity,
                                  DsgRate
                                );
                              }}
                            >
                              Add
                            </Button>
                          )}
                        </DialogTitle>
                      </div>
                      <DialogContent
                        sx={{
                          transition: "ease-in-out",
                          minWidth: "600px",
                          py: 1,
                        }}
                      >
                        <Grid
                          container
                          spacing={1.3}
                          columns={12}
                          sx={{ mt: 1, width: "100%" }}
                        >
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            sx={{
                              display: "flex",
                              justifyContent: "start",
                            }}
                          >
                            {shouldReRender ? (
                              <Autocomplete
                                id="Mui-Autocomplete-SupplyDesign"
                                sx={{ width: SuppDsgnNmCD ? "50%" : "100%" }}
                                renderInput={(params) => (
                                  <TextField
                                    autoFocus
                                    {...params}
                                    label="Design"
                                  />
                                )}
                              />
                            ) : null}
                            {!shouldReRender && (
                              <Autocomplete
                                disableClearable
                                id="Mui-Autocomplete-SupplyDesign"
                                open={ListOpen}
                                onOpen={handleListOpen}
                                onClose={handleListClose}
                                loading={ListLoading}
                                value={SuppDsgnNmCD}
                                onChange={(event, newValue) => {
                                  handleSupDsnCode_ID(newValue);
                                }}
                                options={SupplydsgnList?.sort(sortByLabel)}
                                componentsProps={{
                                  popper: {
                                    style: {
                                      width: "100vw",
                                      maxWidth: "700px",
                                    },
                                  },
                                }}
                                renderOption={(props, item) => (
                                  <table key={item.value}>
                                    {item.value === SupplydsgnList[0]?.value ? (
                                      <tbody {...props} style={{ padding: 0 }}>
                                        <tr>
                                          <td
                                            style={{ width: 400, padding: 0 }}
                                          >
                                            <div
                                              style={{
                                                backgroundColor: "#F3F1F1",
                                                padding: "6px 16px",
                                                paddingRight: 0,
                                                fontWeight: 600,
                                              }}
                                            >
                                              Supply Design
                                            </div>
                                            <div
                                              style={{
                                                padding: "6px 16px",
                                                paddingRight: 0,
                                              }}
                                            >
                                              {SupplydsgnList[0]?.label}
                                            </div>
                                          </td>
                                          <td
                                            style={{ width: 300, padding: 0 }}
                                          >
                                            <div
                                              style={{
                                                backgroundColor: "#F3F1F1",
                                                padding: "6px 16px",
                                                paddingLeft: 0,
                                                fontWeight: 600,
                                              }}
                                            >
                                              Product
                                            </div>
                                            <div
                                              style={{
                                                padding: "6px 16px",
                                                paddingLeft: 0,
                                              }}
                                            >
                                              {SupplydsgnList[0]?.product}
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    ) : (
                                      <tbody {...props}>
                                        <tr>
                                          <td style={{ width: 400 }}>
                                            {item.label}
                                          </td>
                                          <td style={{ width: 300 }}>
                                            {item.product}
                                          </td>
                                        </tr>
                                      </tbody>
                                    )}
                                  </table>
                                )}
                                filterOptions={(options, params) => {
                                  const filtered = filter(options, params);
                                  if (
                                    params.inputValue !== "" &&
                                    filtered?.length < 1
                                  ) {
                                    filtered.push({
                                      label: `Add "${params.inputValue}"`,
                                      value: 0,
                                    });
                                  }
                                  return filtered;
                                }}
                                getOptionLabel={(option) =>
                                  option.label ? option.label : ""
                                }
                                isOptionEqualToValue={(option, value) =>
                                  option?.value === value?.value
                                }
                                sx={{ width: SuppDsgnNmCD ? "50%" : "100%" }}
                                renderInput={(params) => (
                                  <TextField
                                    autoFocus
                                    {...params}
                                    label="Supply Design"
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                        <>
                                          {ListLoading ? (
                                            <CircularProgress
                                              color="inherit"
                                              size={20}
                                              sx={{ mt: -1 }}
                                            />
                                          ) : null}
                                          {params.InputProps.endAdornment}
                                        </>
                                      ),
                                    }}
                                  />
                                )}
                              />
                            )}
                          </Grid>
                        </Grid>

                        {SuppDsgnNmCD || PodIdNme ? (
                          <>
                            <Grid
                              container
                              spacing={1.3}
                              columns={12}
                              sx={{ mt: 1, width: "100%" }}
                            >
                              <Grid
                                item
                                xs={12}
                                sm={6}
                                md={3}
                                lg={3}
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                {shouldReRender ? (
                                  <TextField
                                    id="Product"
                                    label="Product"
                                    sx={{ width: "100%" }}
                                  />
                                ) : null}
                                {!shouldReRender && (
                                  <TextField
                                    disabled
                                    id="Product"
                                    label="Product"
                                    value={PodIdNme?.label}
                                    InputLabelProps={{
                                      shrink:
                                        PodIdNme?.label != undefined
                                          ? true
                                          : false,
                                    }}
                                    sx={{ width: "100%" }}
                                  />
                                )}
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={6}
                                md={3}
                                lg={3}
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                {shouldReRender ? (
                                  <TextField
                                    id="Qty"
                                    label="Qty"
                                    sx={{ width: "100%" }}
                                  />
                                ) : null}
                                {!shouldReRender &&
                                  (IsClrSize === true ? (
                                    <TextField
                                      disabled
                                      id="Qty"
                                      label="Qty"
                                      value={TotalQuantity}
                                      InputLabelProps={{
                                        shrink:
                                          TotalQuantity != undefined
                                            ? true
                                            : false,
                                      }}
                                      InputProps={{
                                        inputProps: { min: 0 },
                                      }}
                                      type="number"
                                      sx={{ width: "100%" }}
                                    />
                                  ) : (
                                    <TextField
                                      id="Qty"
                                      label="Qty"
                                      value={TotalQuantity}
                                      onChange={handleQuantity}
                                      onBlur={() => setQtyInputfocus(false)}
                                      inputRef={(input) =>
                                        QtyInputfocus && !Loader && input?.focus()
                                      }
                                      InputLabelProps={{
                                        shrink:
                                          TotalQuantity != undefined
                                            ? true
                                            : false,
                                      }}
                                      InputProps={{
                                        inputProps: {
                                          min: 0,
                                        },
                                      }}
                                      type="number"
                                      sx={{ width: "100%" }}
                                    />
                                  ))}
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={6}
                                md={3}
                                lg={3}
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                {shouldReRender ? (
                                  <TextField
                                    id="Rate"
                                    label="Rate"
                                    sx={{ width: "100%" }}
                                  />
                                ) : null}
                                {!shouldReRender && (
                                  <TextField
                                    id="Rate"
                                    label="Rate"
                                    value={DsgRate}
                                    onChange={handleRateChange}
                                    InputProps={{ inputProps: { min: 0 } }}
                                    type="number"
                                    InputLabelProps={{
                                      shrink:
                                        DsgRate != undefined ? true : false,
                                    }}
                                    sx={{ width: "100%" }}
                                  />
                                )}
                                {shouldReRender ? (
                                  <TextField
                                    id="Discount%"
                                    label="Discount %"
                                    sx={{ width: "100%" }}
                                  />
                                ) : null}
                                {!shouldReRender &&
                                  (isDisAmt == true ? (
                                    <TextField
                                      disabled
                                      id="Discount%"
                                      label="Discount %"
                                      value={DiscountPer}
                                      InputLabelProps={{
                                        shrink:
                                          DiscountPer != undefined
                                            ? true
                                            : false,
                                      }}
                                      sx={{ width: "100%" }}
                                    />
                                  ) : (
                                    <TextField
                                      id="Discount%"
                                      label="Discount %"
                                      value={DiscountPer}
                                      onChange={handleDiscountPer}
                                      InputLabelProps={{
                                        shrink:
                                          DiscountPer != undefined
                                            ? true
                                            : false,
                                      }}
                                      inputProps={{
                                        maxlength: 4,
                                      }}
                                      sx={{ width: "100%" }}
                                    />
                                  ))}
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={6}
                                md={3}
                                lg={3}
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Checkbox
                                  checked={isDisAmt}
                                  onChange={() => {
                                    return setIsDisAmt(!isDisAmt);
                                  }}
                                  inputProps={{ "aria-label": "controlled" }}
                                />
                                {shouldReRender ? (
                                  <TextField
                                    id="Discount Amt."
                                    label="Discount Amt."
                                    sx={{ width: "100%" }}
                                  />
                                ) : null}
                                {!shouldReRender &&
                                  (isDisAmt == true ? (
                                    <TextField
                                      id="Discount Amt."
                                      label="Discount Amt."
                                      value={DiscountAmt}
                                      onChange={handleDiscountAmt}
                                      InputLabelProps={{
                                        shrink:
                                          DiscountAmt != undefined
                                            ? true
                                            : false,
                                      }}
                                      sx={{ width: "100%" }}
                                    />
                                  ) : (
                                    <TextField
                                      disabled
                                      id="Discount Amt."
                                      label="Discount Amt."
                                      value={DiscountAmt}
                                      InputLabelProps={{
                                        shrink:
                                          DiscountAmt != undefined
                                            ? true
                                            : false,
                                      }}
                                      sx={{ width: "100%" }}
                                    />
                                  ))}
                                {shouldReRender ? (
                                  <TextField
                                    disabled
                                    id="After Dis. Rate"
                                    label="After Dis. Rate"
                                    sx={{ width: "100%" }}
                                  />
                                ) : null}
                                {!shouldReRender && (
                                  <TextField
                                    disabled
                                    id="After Dis. Rate"
                                    label="After Dis. Rate"
                                    value={DiscountedRate(DsgRate, DiscountPer)}
                                    InputLabelProps={{
                                      shrink:
                                        DiscountedRate(DsgRate, DiscountPer) != undefined
                                          ? true
                                          : false,
                                    }}
                                    sx={{ width: "100%" }}
                                  />
                                )}
                              </Grid>

                              <Grid
                                item
                                xs={12}
                                sm={6}
                                md={3}
                                lg={3}
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                {shouldReRender ? (
                                  <TextField
                                    id="Amount BFT"
                                    label="Amount BFT"
                                    sx={{ width: "100%" }}
                                  />
                                ) : null}
                                {!shouldReRender && (
                                  <TextField
                                    disabled
                                    id="Amount BFT"
                                    label="Amount BFT"
                                    value={AmountBFT}
                                    InputLabelProps={{
                                      shrink:
                                        AmountBFT != undefined ? true : false,
                                    }}
                                    InputProps={{ inputProps: { min: 0 } }}
                                    type="number"
                                    sx={{ width: "100%" }}
                                  />
                                )}
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={6}
                                md={3}
                                lg={3}
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                {shouldReRender ? (
                                  <>
                                    <TextField
                                      id="CGST"
                                      label="CGST%"
                                      InputProps={{ inputProps: { min: 0 } }}
                                      type="number"
                                      sx={{ width: "30%" }}
                                    />
                                    <TextField
                                      id="CGSTAmt"
                                      label="CGSTAmt"
                                      InputProps={{ inputProps: { min: 0 } }}
                                      type="number"
                                      sx={{ width: "70%" }}
                                    />
                                  </>
                                ) : null}
                                {!shouldReRender && (
                                  <>
                                    <TextField
                                      disabled
                                      id="CGST"
                                      label="CGST%"
                                      value={GstRates?.cgst}
                                      InputLabelProps={{
                                        shrink:
                                          GstRates?.cgst != undefined ? true : false,
                                      }}
                                      InputProps={{ inputProps: { min: 0 } }}
                                      type="number"
                                      sx={{ width: "30%" }}
                                    />
                                    <TextField
                                      disabled
                                      id="CGSTAmt"
                                      label="CGSTAmt"
                                      value={cgstValue}
                                      InputLabelProps={{
                                        shrink:
                                          cgstValue != undefined ? true : false,
                                      }}
                                      InputProps={{ inputProps: { min: 0 } }}
                                      type="number"
                                      sx={{ width: "70%" }}
                                    />
                                  </>
                                )}
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={6}
                                md={3}
                                lg={3}
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                {shouldReRender ? (
                                  <>
                                    <TextField
                                      id="SGST"
                                      label="SGST%"
                                      InputProps={{ inputProps: { min: 0 } }}
                                      type="number"
                                      sx={{ width: "30%" }}
                                    />
                                    <TextField
                                      id="SGSTAmt"
                                      label="SGSTAmt"
                                      InputProps={{ inputProps: { min: 0 } }}
                                      type="number"
                                      sx={{ width: "70%" }}
                                    />
                                  </>
                                ) : null}
                                {!shouldReRender && (
                                  <>
                                    <TextField
                                      disabled
                                      id="SGST"
                                      label="SGST%"
                                      value={GstRates?.sgst}
                                      InputLabelProps={{
                                        shrink:
                                          GstRates?.sgst != undefined ? true : false,
                                      }}
                                      InputProps={{ inputProps: { min: 0 } }}
                                      type="number"
                                      sx={{ width: "30%" }}
                                    />
                                    <TextField
                                      disabled
                                      id="SGSTAmt"
                                      label="SGSTAmt"
                                      value={sgstValue}
                                      InputLabelProps={{
                                        shrink:
                                          sgstValue != undefined ? true : false,
                                      }}
                                      InputProps={{ inputProps: { min: 0 } }}
                                      type="number"
                                      sx={{ width: "70%" }}
                                    />
                                  </>
                                )}
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={6}
                                md={3}
                                lg={3}
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                {shouldReRender ? (
                                  <>
                                    <TextField
                                      id="IGST"
                                      label="IGST%"
                                      InputProps={{ inputProps: { min: 0 } }}
                                      type="number"
                                      sx={{ width: "30%" }}
                                    />
                                    <TextField
                                      id="IGSTAmt"
                                      label="IGSTAmt"
                                      InputProps={{ inputProps: { min: 0 } }}
                                      type="number"
                                      sx={{ width: "70%" }}
                                    />
                                  </>
                                ) : null}
                                {!shouldReRender && (
                                  <>
                                    <TextField
                                      disabled
                                      id="IGST"
                                      label="IGST%"
                                      value={GstRates?.igst}
                                      InputLabelProps={{
                                        shrink:
                                          GstRates?.igst != undefined ? true : false,
                                      }}
                                      InputProps={{ inputProps: { min: 0 } }}
                                      type="number"
                                      sx={{ width: "30%" }}
                                    />
                                    <TextField
                                      disabled
                                      id="IGSTAmt"
                                      label="IGSTAmt"
                                      value={igstValue}
                                      InputLabelProps={{
                                        shrink:
                                          igstValue != undefined ? true : false,
                                      }}
                                      InputProps={{ inputProps: { min: 0 } }}
                                      type="number"
                                      sx={{ width: "70%" }}
                                    />
                                  </>
                                )}
                              </Grid>

                              <Grid
                                item
                                xs={12}
                                sm={6}
                                md={3}
                                lg={3}
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                {shouldReRender ? (
                                  <TextField
                                    id="TotalAmount"
                                    label="Total Amount"
                                    sx={{ width: "100%" }}
                                  />
                                ) : null}
                                {!shouldReRender && (
                                  <TextField
                                    disabled
                                    id="TotalAmount"
                                    label="Total Amount"
                                    value={itemTotalAmt}
                                    InputLabelProps={{
                                      shrink:
                                        itemTotalAmt != undefined
                                          ? true
                                          : false,
                                    }}
                                    InputProps={{ inputProps: { min: 0 } }}
                                    type="number"
                                    sx={{ width: "100%" }}
                                  />
                                )}
                              </Grid>
                            </Grid>
                            {IsClrSize ? (
                              <TableContainer
                                component={Paper}
                                sx={{
                                  mt: 2,
                                  minWidth: "60vw",
                                }}
                              >
                                <ThemeProvider theme={innerformClr}>
                                  <Table
                                    stickyHeader
                                    size="small"
                                    aria-label="simple table"
                                  >
                                    <TableHead>
                                      <TableRow>
                                        <TableCell sx={{ py: 2 }}>
                                          Color/Size
                                        </TableCell>
                                        {UniqueSizes?.map(
                                          (item, index) => (
                                            <TableCell
                                              align="center"
                                              key={index}
                                            >
                                              {item}
                                            </TableCell>
                                          ))}
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {(!shouldReRenderRaw
                                        ? RawClrSize
                                        : []
                                      )?.map((item, index) => {
                                        return (
                                          <TableRow key={index}>
                                            <TableCell>
                                              {item?.color_name}
                                            </TableCell>
                                            {UniqueSizes?.map((elem, index) =>
                                              item?.sizes?.find((el) => el?.size_name == elem) ?
                                                <TableCell
                                                  key={index}
                                                  align="center"
                                                >
                                                  <TextField
                                                    name={
                                                      item?.color_name +
                                                      "." +
                                                      item?.sizes?.find((el) => el?.size_name == elem)?.size_name
                                                    }
                                                    label="Qty"
                                                    value={
                                                      item?.sizes?.find((el) => el?.size_name == elem)?.qty
                                                    }
                                                    onChange={
                                                      ClrSizehandler
                                                    }
                                                    InputProps={{
                                                      inputProps: {
                                                        min: 0,
                                                      },
                                                    }}
                                                    type="number"
                                                    InputLabelProps={{
                                                      shrink:
                                                        item?.sizes?.find((el) => el?.size_name == elem)?.qty !=
                                                          undefined
                                                          ? true
                                                          : false,
                                                    }}
                                                    sx={{ mt: 0.4 }}
                                                  />
                                                </TableCell>
                                                :
                                                <TableCell align="center">
                                                  -
                                                </TableCell>
                                            )}
                                          </TableRow>
                                        );
                                      })}
                                    </TableBody>
                                  </Table>
                                  {/* <Box sx={{ px: 1 }}>
                                    <Tooltip title="Add Color/Size">
                                      <IconButton
                                        color="primary"
                                        aria-label="add"
                                      >
                                        <AddCircleOutlinedIcon
                                          onClick={handleModalOpenAddClrSize}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </Box> */}
                                </ThemeProvider>
                              </TableContainer>
                            ) : (
                              // <Box style={{ display: "flex", justifyContent: "center", padding: "15px" }}>
                              //   No Color/Size Available
                              // </Box>
                              <></>
                            )}
                          </>
                        ) : (
                          <></>
                        )}
                      </DialogContent>
                    </Dialog>
                  </TabPanel>
                </TabContext>
              </Box>
            </ThemeProvider>
          </div>
          <ThemeProvider theme={form}>
            <Paper
              sx={{
                py: 1.5,
                width: "100%",
                height: "58px",
                overflowY: "scroll",
                "::-webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              <Grid
                container
                spacing={1.3}
                columns={12}
                sx={{ width: "100%", padding: "0 10px 0 10px" }}
              >
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2}
                  lg={2}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <TextField
                    disabled
                    id="Qty"
                    label="Qty"
                    value={mainTotalQty}
                    InputLabelProps={{
                      shrink: mainTotalQty != undefined ? true : false,
                    }}
                    InputProps={{ inputProps: { min: 0 } }}
                    type="number"
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2}
                  lg={2}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <TextField
                    disabled
                    id="Taxable"
                    label="Taxable"
                    value={mainTotalTaxableAmt}
                    InputLabelProps={{
                      shrink: mainTotalTaxableAmt != undefined ? true : false,
                    }}
                    InputProps={{ inputProps: { min: 0 } }}
                    type="number"
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2}
                  lg={2}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <TextField
                    disabled
                    id="CGST"
                    label="CGST"
                    value={mainTotalItemCgst}
                    InputLabelProps={{
                      shrink: mainTotalItemCgst != undefined ? true : false,
                    }}
                    InputProps={{ inputProps: { min: 0 } }}
                    type="number"
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2}
                  lg={2}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <TextField
                    disabled
                    id="SGST"
                    label="SGST"
                    value={mainTotalItemSgst}
                    InputLabelProps={{
                      shrink: mainTotalItemSgst != undefined ? true : false,
                    }}
                    InputProps={{ inputProps: { min: 0 } }}
                    type="number"
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2}
                  lg={2}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <TextField
                    disabled
                    id="IGST"
                    label="IGST"
                    value={mainTotalItemIgst}
                    InputLabelProps={{
                      shrink: mainTotalItemIgst != undefined ? true : false,
                    }}
                    InputProps={{ inputProps: { min: 0 } }}
                    type="number"
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2}
                  lg={2}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <TextField
                    disabled
                    id="Total Amount"
                    label="Total Amount"
                    value={mainTotalAmount}
                    InputLabelProps={{
                      shrink: mainTotalAmount != undefined ? true : false,
                    }}
                    InputProps={{ inputProps: { min: 0 } }}
                    type="number"
                    sx={{ width: "100%" }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </ThemeProvider>
          {/* <TotalDetail
            mainTotalQty={mainTotalQty}
            mainTotalTaxableAmt={mainTotalTaxableAmt}
            mainTotalCgst={mainTotalItemCgst}
            mainTotalSgst={mainTotalItemSgst}
            mainTotalIgst={mainTotalItemIgst}
            mainTotalAmount={mainTotalAmount}
          /> */}
        </ThemeProvider>
      </div>

      <Toaster position="top-center" reverseOrder={false} />
    </>
  );
}
